'use strict';

import React, { Component, useDebugValue } from 'react';
import { render } from 'react-dom';
import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { MenuModule } from '@ag-grid-enterprise/menu';
// import Consignmentforceclose from '../m';
import DrawMap from '../common/drawmap';
import CommentActions from "../layouts/commentsComponent";
import ForceCloseSideBar from "./forceclosuresidebarcomponent";
import { AllModules, GridOptionsWrapper } from '@ag-grid-enterprise/all-modules';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import MarkDeliver from "../layouts/markDeliveredButton.js";
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import ConsignmentActions from '../manage/ConsignmentActionsComponent';
import CountUp from 'react-countup';
import SweetAlert from 'react-bootstrap-sweetalert';
import Consignmentforceclose from '../manage/consignmentforceclose';
import UpdateButton from "./updatelmstates";
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import CellGraphComponent from './cellGraphComponent';
import $ from 'jquery';
import ColumnGroup from './columngroupComponent';
import { getDDMMYYYY, getHyphenYYYYMMDD,getHyphenDDMMMYYYYHHMM,getHyphenDDMMMYYYY,getHyphenYYYYMMDDHHMMSS,getHyphenDDMMYYYYHHMMSS,getDDMMYYYYHHMMSS, getYYYYMMDD, getYYYYMMDDHHMMSS, getCellValue } from '../common/utils'; 
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { HardwareDesktopWindows } from 'material-ui/svg-icons';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from "@fullcalendar/timegrid";
import { Edit, Trash, Eye, Route as RouteIcon, Filter as FilterIcon, X as XIcon } from 'lucide-react';
import Select from 'react-select';
import XLSX from "xlsx/dist/xlsx.full.min.js";
import { LoadingPortContext, resolvePageAccess } from '../../context/LoadingPortContext';
// const $ = window.$;
window.jQuery = $;
window.$ = $;
var redirectURL = require('../redirectURL');
var moment = require('moment');
var filecontent="";
var googleAnalytics = require("../common/googleanalytics");
var CELL_DIMENSION_SIZE = 90;




export default class LmRouteConfig extends Component {
  static contextType = LoadingPortContext;

  constructor(props, context) {
    super(props, context);
    this._lastLoadingPortCode = context ? context.loading_port_code : null;
      this.state = {
        modules : AllModules,
        defaultColDef: {
            sortable: true,
            filter: true,
            editable: true,
        },
        eventAction: null,
        show: false,
        frameworkComponents : {
          consignmentforceclose:Consignmentforceclose,
          consignmentActions:ConsignmentActions,
          UpdateButton:UpdateButton,
          MarkDeliver : MarkDeliver,
          commentActions : CommentActions,
          routeActionRenderer: this.RouteActionRenderer,
          zoneGroupInnerRenderer: this.ZoneGroupInnerRenderer,
          countBadgeRenderer: this.CountBadgeRenderer
        },
        modified_by:"",
        basicTitle:'',
        reasonforceclose:"",
        bulkslide:"",
        file:"",
        uploadFile:"",
        basicType:"default",
        loadshow:'show-n',
        forceCloseRowNode : "",
        forceclosedata:"",
        csvcontent:"",
        sliderForceCloseTranslate:"",
        overly:'',
        rowData:[],
        bulkslide:"",
        showDiv:"",
        uploadDivWidth:"",
        isMapOpen: false,
        routeMapWarehouse: null,
        routeMapCities: [],
        routeMapHeaderTitle: "",
        routeMapWarehouseInfo: "",
        mapinfo:"",
        dealer:"",
        sliderCommentTranslate:"",
        commentsRowData:"",
        consignment_code:"",
        sliderRouteTranslate:"",
        maptruckno:"",
        routeTruck:	"",
        rownode:"",
        googelRoutes:"",
        file:"",
        rowSelection:'multiple',
        sliderForceCloseTranslate:"",
        maptruckno:"",
        rowModelhighchartoptionsType: 'enterprise',
        rowGroupPanelShow: 'always',
            statusBar: {
        statusPanels: [
          {
          statusPanel: "agTotalAndFilteredRowCountComponent",
          align: "left"
          },
          {
          statusPanel: "agTotalRowCountComponent",
          align: "center"
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" }
        ]
            },
        paginationPageSize:200,
        geofencelist:[],
        geoFenceData:"",
        sideBar: {
          toolPanels: [
            {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel"
            },
            {
            id: "filters",
            labelDefault: "Filters",
            labelKey: "filters",
            iconKey: "filter",
            toolPanel: "agFiltersToolPanel"
            }
          ]
        },
        animateRows: true,
        dept_code:"",
        pagetitle:"",
        markDeliverRowNode : "",
        markDeliverData:"",
        sliderMarkDeliverTranslate:"",
        overly:"show-n",
        loadshow:"show-n",
        holidayEvents : [],
        showCalendar : "show-m",
        showGridData : "show-m",
        vehicleCap : [],
        statesList : [],
        citiesList : [],
        rowIds : [],
        comp_code : "",
        lpNames : [],
        loading_port_code : "",
        zonesList : [],
        routesList : [],
        cityGroup : [],
        data_type:1,
        regularActive : "activet",
        truckActive : "",
        courierActive : "",
        selectedRows : [],
        selectedRowsApi : null,
        errors : [],
        validData : [],
        bulkUploadSubmitting : false,
        isDeleting : false,
        // In-app confirmation dialog. Replaces window.confirm, which renders the browser's own
        // "<host> says" box - out of place beside every other message on this screen, unstyled,
        // and it blocks the JS thread.
        confirmAlert : {
            open : false,
            title : "",
            message : "",
            confirmText : "Continue",
            type : "warning",
            onConfirm : null
        },
        fileName : "",
        // Zone stays an inline, always-visible single-select dropdown (like
        // the original design) since it's the "top" of the cascade and gets
        // used most often. State and City are both multi-select, tucked behind
        // the Filters popup so their tag lists don't push the header around.
        selectedZoneFilter : "",
        stateFilterOptions : [],
        selectedStateFilter : [],
        cityFilterOptions : [],
        selectedCityFilter : [],
        // Filters popup (Apply/Cancel) for State/City only - draftXFilter/
        // draftXOptions hold in-progress edits so Cancel can discard them
        // without touching the actually-applied selectedXFilter/xFilterOptions.
        filterPopupOpen : false,
        draftStateFilter : [],
        draftCityFilter : [],
        draftStateOptions : [],
        draftCityOptions : [],
        // Route builder slider - multi-add/edit of a route's city locations,
        // staged locally and only persisted on Submit.
        routeBuilderOpen: false,
        routeBuilderMode: "add",
        routeBuilderRoute: "",
        routeBuilderRouteOptions: [],
        routeBuilderZone: "",
        routeBuilderState: "",
        routeBuilderCity: "",
        routeBuilderCityGrouping: "",
        routeBuilderRows: [],
        routeBuilderSelectedTempKeys: [],
        routeBuilderOriginalChildren: [],
        routeBuilderOriginalRoute: "",
        routeBuilderSubmitting: false,
        routeBuilderDistinctStates: [],
        routeBuilderStateOptions: [],
        routeBuilderDistinctCities: [],
        routeBuilderCityOptions: [],
        routeBuilderDistinctCityGroupings: [],
        routeBuilderWarehouse: null,
        //components : {datepicker:getDatePicker()}
    }
    this.onCellClicked = this.onCellClicked.bind(this);
    this.gridRef = React.createRef();
    this.fileInputRef = React.createRef();
    // Route map data doesn't need to trigger re-renders on its own, and shouldn't be
    // re-fetched from scratch on every single map click - cache per loading port.
    this._consigneesCacheByPort = {};
    this._loadingPortsCache = null;
    this._sobZonesCacheByPort = {};
  }

componentDidMount(){
    loadDateTimeScript();
    this.pageAccess();
    // zonesList used to be a hardcoded 25-entry list here - now fetched per loading
    // port in fetchZones(), same as lmvehiclecapacity.js's getLmSobUniqueZones call.
    var routesList = [];
    var rtList = 50;
    for(var rt=1;rt<51;rt++)
    {
        routesList.push("ROUTE"+rt);
    }
    var groupList = [];
    for(var rt=1;rt<51;rt++)
    {
        groupList.push("GROUP"+rt);
    }
    this.setState({
        routesList : routesList,
        cityGroup : groupList,
    });
    // redirectURL.post("/lmconsignees/getLmStates").then((response)=>{
    //     var states = response.data;
    //     var statesList = [];
    //     if(states.length > 0)
    //     {
    //         states.map((item) =>{
    //             statesList.push(item.state)
    //         })
    //     }
    //     this.setState({
    //         statesList : statesList,
    //     })
    // }).catch((e)=>{
    //     console.log(e);
    // })
}

async pageAccess(){
    this.setState({
        loadshow:'show-m',
        overly:'show-m',
    })
    var currentUrl = this.props.match.path;
    var resolved = await resolvePageAccess(currentUrl, this.context);
    if (!resolved) {
        // No access (already alerted+redirected), empty port list, or a logged request error.
        this.setState({ loadshow: 'show-n', overly: 'show-n' });
        return;
    }
    this._lastLoadingPortCode = resolved.loading_port_code;
    // Switching loading port reloads a whole new set of rows too - clear any
    // selection made on the previous port's grid for the same reason as onClickTab.
    if (this.state.selectedRowsApi) {
        try { this.state.selectedRowsApi.deselectAll(); } catch (e) { console.log(e); }
    }
    this.setState({
        pageAccess: resolved.pageAccess,
        loading_port_code: resolved.loading_port_code,
        comp_code: resolved.comp_code,
        lpNames: resolved.lpNames,
        selectedZoneFilter: "",
        selectedStateFilter: [],
        selectedCityFilter: [],
        selectedRows: [],
        selectedRowsApi: null,
    });
    await this.fetchZones(resolved.loading_port_code);
    // Keep the loader up until rowData is actually set - the grid's route
    // grouping runs synchronously off rowData in render(), so hiding the loader
    // any earlier shows a blank/stale grid while that grouping still has to happen.
    await this.onLoadPageData();
    this.setState({ loadshow: 'show-n', overly: 'show-n' });
    // Warm the consignees cache for this port now (not awaited) so the route
    // builder slider's State/City/City Grouping dropdowns are instant instead of
    // triggering a fresh getLmConsignees call on the first Add/Edit click.
    this.fetchConsigneesForMap(resolved.loading_port_code);
}

// Same source as lmvehiclecapacity.js: the SOB zones master for this loading
// port, instead of a hardcoded zone list.
fetchZones(loading_port_code) {
    return redirectURL.post("/lmconsignees/getLmSobUniqueZones", { loading_port_code }).then((response) => {
        var zonesList = (response.data || []).map((item) => String(item).toUpperCase());
        return new Promise(resolve => this.setState({ zonesList }, resolve));
    }).catch((e) => {
        console.log(e);
    });
}

onLoadPageData(){
    var loading_port_code = this.state.loading_port_code;
    var data_type = this.state.data_type;
    var params = {
        loading_port_code : loading_port_code,
        data_type : data_type,
    }
    console.log(params,"params")

    redirectURL.post("/lmconsignees/getLmConsigneeStateAndCities",params).then((response)=>{
        var states = response.data.states;
        var cities = response.data.cities;
        this.setState({
            statesList : states,
            citiesList : cities,
        })
    }).catch((e)=>{
        console.log(e);
    })
    // Returned so callers can await the point where rowData (and therefore the
    // grid's route grouping, computed synchronously in render from rowData) is
    // actually ready - hiding a loader before this resolves shows a blank grid.
    return redirectURL.post("/lmconsignees/lmRouteConfig",params).then((response)=>{
        console.log(response.data);
        var zonesList = this.state.zonesList;
        // The zone filter dropdown is driven by zonesList (this port's SOB zones
        // master, fetched in fetchZones) rather than by zones present in this
        // response - route-config rows can be empty for a port/tab while the port
        // itself still has zones, and the filter should keep listing them so the
        // user can pick one and see "no data for this zone" rather than an empty
        // dropdown. Any zone found in the actual data but missing from the SOB
        // master still gets folded in here, same as before.
        if(response.data.length > 0)
        {
            var distinctZonesData = distinctArrayBy(response.data,"zone");
            if(distinctZonesData.length > 0)
            {
                var distinctZones = [];
                distinctZonesData.map((dz)=>{
                    if(dz.zone) distinctZones.push(dz.zone.toUpperCase());
                });
                distinctZones = distinctArrayWithoutKeys(distinctZones);
                if(distinctZones.length > 0)
                {
                    var allzones = [...zonesList,...distinctZones];
                    var uniqueZones = distinctArrayWithoutKeys(allzones);
                    if(uniqueZones.length > 0)
                    {
                        this.setState({
                            zonesList:uniqueZones
                        });
                    }
                }
            }
        }
        // Same source as the render-time zone filter dropdown (zonesList,
        // this port's SOB Zones master, already merged with any stray zone
        // found in the route data above) - was computeDistinctZones(response.data)
        // here, which meant the "auto-pick if there's only one option" logic
        // didn't actually match what the dropdown itself was offering.
        var loadedZoneOptions = this.state.zonesList;
        var loadedSelectedZone = this.pickIfSingle(loadedZoneOptions);
        var loadedStateOptions = this.computeDistinctStates(response.data, loadedSelectedZone);
        var loadedSelectedState = this.pickMultiDefault(loadedStateOptions);
        var loadedCityOptions = this.computeDistinctCities(response.data, loadedSelectedZone, loadedSelectedState);
        var loadedSelectedCity = this.pickMultiDefault(loadedCityOptions);
        this.setState({
            rowData : response.data,
            selectedZoneFilter : loadedSelectedZone,
            stateFilterOptions : loadedStateOptions.map((v) => ({ label: v, value: v })),
            selectedStateFilter : loadedSelectedState,
            cityFilterOptions : loadedCityOptions.map((v) => ({ label: v, value: v })),
            selectedCityFilter : loadedSelectedCity,
        })
    }).catch((e)=>{
        console.log(e);
    })
}
// Distinct states/cities present in this screen's own saved route-config rows,
// scoped to whatever Zone (inline, single-select, applies immediately) and
// States (multi-select, inside the Filters popup) are already picked - drives
// the Zone -> State -> City cascade.
computeDistinctStates = (rows, zone) => {
    var filtered = zone ? rows.filter((r) => (r.zone || "").toUpperCase() === zone.toUpperCase()) : rows;
    var states = [];
    filtered.forEach((r) => {
        var st = (r.state || "").trim().toUpperCase();
        if (st && states.indexOf(st) === -1) states.push(st);
    });
    states.sort();
    return states;
};
computeDistinctCities = (rows, zone, states) => {
    var filtered = zone ? rows.filter((r) => (r.zone || "").toUpperCase() === zone.toUpperCase()) : rows;
    var statesUpper = (states || []).map((s) => (s || "").toUpperCase());
    if (statesUpper.length > 0) filtered = filtered.filter((r) => statesUpper.indexOf((r.state || "").toUpperCase()) !== -1);
    var cities = [];
    filtered.forEach((r) => {
        var ct = (r.city || "").trim().toUpperCase();
        if (ct && cities.indexOf(ct) === -1) cities.push(ct);
    });
    cities.sort();
    return cities;
};
// An "All X" option only makes sense as a choice when there's more than one
// real value to pick between - with 0 or 1, it's either nothing to filter or
// a no-op, so just show the plain value (or nothing) instead. Used for Zone,
// which stays single-select.
toFilterOptions = (values, allLabel) => {
    var options = values.map((v) => ({ label: v, value: v }));
    return values.length > 1 ? [{ label: allLabel, value: "" }].concat(options) : options;
};
// With no "All" choice offered once there's only one real value (see
// toFilterOptions above), leaving the filter unselected would just show a
// placeholder for a decision that isn't really a choice - pick it automatically.
pickIfSingle = (values) => values.length === 1 ? values[0] : "";
// State and City are both multi-select filters - with no "All X" choice ever
// offered (unlike Zone's single-select), leaving a filter unselected already
// means "everything"; when there's only exactly one real option though,
// there's no real choice to make, so auto-select it.
pickMultiDefault = (values) => values.length === 1 ? [values[0]] : [];

// With one or more cities selected, show every city that belongs to the SAME
// route as any selected city - not just the selected city's own row - so the
// user sees the full route instead of a fragment of it. Route identity here
// matches groupedRouteData's own grouping key: zone+route when "All Zones" is
// selected (the same route name can repeat across zones), plain route otherwise.
expandRowsToFullRoutesForCityFilter = (rows, isAllZones, selectedCities) => {
    if (!selectedCities || selectedCities.length === 0) return rows;
    var selectedCitiesUpper = selectedCities.map((c) => (c || "").toUpperCase());
    var routeKey = (r) => isAllZones ? ((r.zone || "") + "___" + (r.route || "")) : (r.route || "");
    var qualifyingKeys = new Set();
    rows.forEach((r) => {
        if (selectedCitiesUpper.indexOf((r.city || "").toUpperCase()) !== -1) {
            qualifyingKeys.add(routeKey(r));
        }
    });
    return rows.filter((r) => qualifyingKeys.has(routeKey(r)));
};

// ONE CITY -> ONE ZONE. Reports any (state, city) in the loaded grid carrying more than one
// zone. Such rows are accepted by every screen and collection, but the planning engine reads
// them as a { (state, city): zone } dict (dealer.read_dealer_details) that overrides the
// state-level SOB zone - so a duplicate is silently last-row-wins, and because the route key
// is state+city+city_grouping with NO zone, the consignee also receives the UNION of both
// zones' routes. Route numbers repeat across zones, so two consignees can appear to share a
// route that means two different physical runs. The write paths now refuse to create a new
// one; pre-existing rows still need a human to resolve, which is what this surfaces.
getMultiZoneCities(){
    var zoneCompareKey = (v) => String(v || "").toUpperCase().replace(/\s+/g, "");
    var byCity = {};
    (this.state.rowData || []).forEach((row) => {
        var state = String(row.state || "").trim().toUpperCase();
        var city = String(row.city || "").trim().toUpperCase();
        var zone = String(row.zone || "").trim();
        if(!state || !city || !zone) return;
        var key = state + "|" + city;
        if(!byCity[key]) byCity[key] = { key: key, state: state, city: city, zones: [] };
        if(byCity[key].zones.map(zoneCompareKey).indexOf(zoneCompareKey(zone)) === -1){
            byCity[key].zones.push(zone);
        }
    });
    return Object.keys(byCity)
        .filter((key) => byCity[key].zones.length > 1)
        .sort()
        .map((key) => byCity[key]);
}

onGridReady = params => {
    this.gridApi = params.api;  
    //console.log("Grid is: ", params);
    this.gridColumnApi = params.columnApi;
};
onGridState = () =>{
        //console.log(this.gridApi);
    
        /*Get  Current Columns State and Store in this.colState */
        this.colState = this.gridColumnApi.getColumnState();

        /*Get Current RowGroup Columns State and Store in this.rowGroupState */
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

        /*Get Current Pivot Columns State and Store in this.pivotColumns, 
        * User should enable the Pivot mode.*/
        this.pivotColumns = this.gridColumnApi.getPivotColumns();
                
        /*Get Current Filter State and Store in window.filterState */
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);
}

 

closeAlert = async () => {
    await this.setState({
        show: false
    });
    await this.onLoadPageData();
}

// Open the in-app confirmation dialog. `onConfirm` runs only when the user accepts;
// dismissing simply closes it, so the caller never has to undo anything.
askConfirm = (options) => {
    this.setState({
        confirmAlert: {
            open: true,
            title: options.title || "Please confirm",
            message: options.message || "",
            confirmText: options.confirmText || "Continue",
            type: options.type || "warning",
            onConfirm: options.onConfirm || null
        }
    });
}

closeConfirm = () => {
    this.setState({ confirmAlert: { open: false, title: "", message: "", confirmText: "Continue", type: "warning", onConfirm: null } });
}

onConfirmAccepted = () => {
    var action = this.state.confirmAlert.onConfirm;
    this.closeConfirm();
    if (typeof action === "function") {
        action();
    }
}

onCellClicked(e)
{
    if(e.colDef.field == "delete")
    {
        var rowId = e.data._id;
        console.log(e.data._id);
        var qry = {
            rowId:rowId,
            city : e.data.city,
            comp_code: this.state.comp_code,
            user_name: localStorage.getItem('username'),
            email: localStorage.getItem('email'),
            user_department: localStorage.getItem('lm_department'),
            staff_id: localStorage.getItem('staff_id'),
            designation: localStorage.getItem('designation'),
            user_role: localStorage.getItem('roles'),
            data_type:  this.state.data_type,
        }
        if (this.state.isDeleting) return;
        // Same in-app dialog as every other message on this screen, instead of the browser's
        // own "<host> says" box.
        this.askConfirm({
            title : "Delete this route configuration?",
            message : (e.data.city ? e.data.city + " " : "")
                + "will lose this route. A consignee city with no route row is dropped as \"No Route Info\".",
            confirmText : "Yes, delete",
            onConfirm : () => {
            this.setState({ isDeleting: true, loadshow: "show-m", overly: "show-m" });
            redirectURL.post("/lmconsignees/deleteLmRoteConfig",qry).then((response)=>{
                console.log(response.data);
                if(response.data.message == "Success")
                {
                    this.setState({
                        basicTitle:"Deleted Successfully.",
                        basicType : "success",
                        show : true,
                        isDeleting: false,
                        loadshow: "show-n",
                        overly: "show-n",
                    })
                    //window.location.reload();
                    this.onLoadPageData();
                }
                else
                {
                    this.setState({
                        basicTitle:"Failed to Delete.",
                        basicType : "warning",
                        show : true,
                        isDeleting: false,
                        loadshow: "show-n",
                        overly: "show-n",
                    })
                }
            }).catch((e)=>{
                console.log(e);
                this.setState({ isDeleting: false, loadshow: "show-n", overly: "show-n" });
            })
            }
        });
    }
}

onClickHideAll(){
    this.setState({
    loadshow:'show-n',
    overly:'show-n',
    bulkslide:"",
    validData:[],
    errors:[],
    fileName:"",
    });

}
// Route builder - a route's city locations are staged locally (add from
// lmconsignees-backed dropdowns, remove from the staged list) and only
// persisted to lmrouteconfig when the user clicks Submit. Same slider handles
// both Add (empty) and Edit (prefilled with the route's existing children).
openRouteBuilder = async (mode, routeGroupData) => {
    this.setState({ overly: "show-m", loadshow: "show-m" });
    try {
        var loading_port_code = this.state.loading_port_code;
        var [consignees, ports] = await Promise.all([
            this.fetchConsigneesForMap(loading_port_code),
            this.fetchLoadingPortsForMap(),
            this.fetchSobZonesForMap(loading_port_code)
        ]);
        var portRecord = ports.find((p) => p.loading_port_code === loading_port_code);
        var warehouse = (portRecord && portRecord.lat && portRecord.lng)
            ? { lat: portRecord.lat, lng: portRecord.lng, label: loading_port_code, city: portRecord.city || "" }
            : null;
        var distinctStates = [];
        var distinctCities = [];
        var distinctCityGroupings = [];
        consignees.forEach((c) => {
            var st = (c.state || "").trim().toUpperCase();
            var ct = (c.city || "").trim().toUpperCase();
            var cg = (c.city_grouping || "").trim().toUpperCase();
            if (st && distinctStates.indexOf(st) === -1) distinctStates.push(st);
            if (ct && distinctCities.indexOf(ct) === -1) distinctCities.push(ct);
            if (cg && distinctCityGroupings.indexOf(cg) === -1) distinctCityGroupings.push(cg);
        });
        distinctStates.sort();
        distinctCities.sort();
        distinctCityGroupings.sort();

        var isEdit = mode === "edit";
        var originalChildren = isEdit ? (routeGroupData.children || []) : [];
        // routeGroupData.children are lmrouteconfig rows - they don't store lat/lng
        // themselves, so each one's map coordinates have to be looked up from the
        // consignees cache, same as a freshly-staged row would be.
        var stagedRows = originalChildren.map((c) => {
            var match = consignees.find((cn) =>
                (cn.state || "").trim().toUpperCase() === (c.state || "").trim().toUpperCase() &&
                (cn.city || "").trim().toUpperCase() === (c.city || "").trim().toUpperCase() &&
                (cn.city_grouping || "").trim().toUpperCase() === (c.city_grouping || "").trim().toUpperCase()
            );
            return {
                _id: c._id, state: c.state, city: c.city, city_grouping: c.city_grouping, zone: c.zone,
                lat: match ? match.lat : null, lng: match ? match.lng : null, tempKey: c._id
            };
        });

        var initialZone = isEdit ? ((originalChildren[0] && originalChildren[0].zone) || "") : "";
        this.setState({
            overly: "show-n", loadshow: "show-n",
            routeBuilderOpen: true,
            routeBuilderMode: mode,
            routeBuilderRoute: isEdit ? (routeGroupData.route || "") : "",
            // Edit mode keeps its own already-saved route fixed (the field is
            // disabled) so its options don't matter; Add mode starts with no
            // zone picked yet, so there's nothing to offer until one is chosen.
            routeBuilderRouteOptions: isEdit ? [routeGroupData.route || ""] : [],
            routeBuilderZone: initialZone,
            routeBuilderOriginalRoute: isEdit ? (routeGroupData.route || "") : "",
            routeBuilderState: "",
            routeBuilderCity: "",
            routeBuilderCityGrouping: "",
            routeBuilderRows: stagedRows,
            routeBuilderSelectedTempKeys: [],
            routeBuilderOriginalChildren: originalChildren,
            routeBuilderDistinctStates: distinctStates,
            routeBuilderStateOptions: initialZone ? this.computeStateOptionsForZone(initialZone, stagedRows) : [],
            routeBuilderDistinctCities: distinctCities,
            routeBuilderCityOptions: distinctCities,
            routeBuilderDistinctCityGroupings: distinctCityGroupings,
            routeBuilderWarehouse: warehouse,
        });
    } catch (e) {
        console.log(e);
        this.setState({ overly: "show-n", loadshow: "show-n", basicTitle: "Failed to load consignee data.", basicType: "warning", show: true });
    }
};
closeRouteBuilder = () => {
    this.setState({ routeBuilderOpen: false });
};
// Which of the fixed ROUTE1..ROUTE50 slots don't already have a saved row
// under this zone - "Add Route" should only ever offer slots that are actually
// free for the picked zone. A zone/route pairing that already exists can only
// be changed via that row's own Edit option, not by adding more rows here.
getAvailableRoutesForZone = (zone) => {
    if (!zone) return [];
    var usedRoutes = [];
    this.state.rowData.forEach((r) => {
        if ((r.zone || "").trim().toUpperCase() === zone.toUpperCase()) {
            var rt = (r.route || "").trim().toUpperCase();
            if (rt && usedRoutes.indexOf(rt) === -1) usedRoutes.push(rt);
        }
    });
    return this.state.routesList.filter((rt) => usedRoutes.indexOf(rt.toUpperCase()) === -1);
};
// States that belong to a given zone, per this port's lmsobzones master - not
// derived from consignees, since consignees don't carry a zone field themselves.
getStatesForZone = (zone) => {
    if (!zone) return [];
    var sobRows = this._sobZonesCacheByPort[this.state.loading_port_code] || [];
    var states = [];
    sobRows.forEach((r) => {
        if ((r.zone || "").trim().toUpperCase() === zone.toUpperCase()) {
            var st = (r.state || "").trim().toUpperCase();
            if (st && states.indexOf(st) === -1) states.push(st);
        }
    });
    states.sort();
    return states;
};
onRouteBuilderZoneChange = (selected) => {
    var newZone = selected ? selected.value : "";
    var statesForZone = this.computeStateOptionsForZone(newZone);
    this.setState({
        routeBuilderZone: newZone,
        routeBuilderRoute: "",
        routeBuilderRouteOptions: this.getAvailableRoutesForZone(newZone),
        routeBuilderStateOptions: statesForZone,
        routeBuilderState: "",
        routeBuilderCity: "",
        routeBuilderCityGrouping: "",
        routeBuilderCityOptions: this.state.routeBuilderDistinctCities
    });
};
// A city drops out of the dropdown once every city_grouping it actually has
// (per this port's consignees) is already staged for it - nothing left to add.
// Cheap: just an in-memory scan of the already-cached, small per-port consignees
// list plus the current staged rows, no extra network calls.
computeCityOptionsForState = (state, rowsOverride) => {
    if (!state) return [];
    var consignees = this._consigneesCacheByPort[this.state.loading_port_code] || [];
    var groupingsByCity = {};
    consignees.forEach((c) => {
        if ((c.state || "").trim().toUpperCase() !== state.toUpperCase()) return;
        var ct = (c.city || "").trim().toUpperCase();
        var cg = (c.city_grouping || "").trim().toUpperCase();
        if (!ct) return;
        if (!groupingsByCity[ct]) groupingsByCity[ct] = [];
        if (cg && groupingsByCity[ct].indexOf(cg) === -1) groupingsByCity[ct].push(cg);
    });
    var stagedGroupingsByCity = {};
    (rowsOverride || this.state.routeBuilderRows).forEach((r) => {
        if ((r.state || "").toUpperCase() !== state.toUpperCase()) return;
        var ct = (r.city || "").toUpperCase();
        var cg = (r.city_grouping || "").toUpperCase();
        if (!stagedGroupingsByCity[ct]) stagedGroupingsByCity[ct] = [];
        if (cg && stagedGroupingsByCity[ct].indexOf(cg) === -1) stagedGroupingsByCity[ct].push(cg);
    });
    var remainingCities = Object.keys(groupingsByCity).filter((ct) => {
        var stagedForCity = stagedGroupingsByCity[ct] || [];
        return groupingsByCity[ct].some((cg) => stagedForCity.indexOf(cg) === -1);
    });
    remainingCities.sort();
    return remainingCities;
};
// Same idea one level up - a state drops out once every one of its cities is
// itself fully staged (no city left with a remaining grouping to add).
computeStateOptionsForZone = (zone, rowsOverride) => {
    var states = this.getStatesForZone(zone);
    return states.filter((st) => this.computeCityOptionsForState(st, rowsOverride).length > 0);
};
onRouteBuilderStateChange = (selected) => {
    var newState = selected ? selected.value : "";
    if (!newState) {
        this.setState({ routeBuilderState: "", routeBuilderCity: "", routeBuilderCityOptions: this.state.routeBuilderDistinctCities });
        return;
    }
    var citiesForState = this.computeCityOptionsForState(newState);
    this.setState({
        routeBuilderState: newState,
        routeBuilderCity: citiesForState.length === 1 ? citiesForState[0] : "",
        routeBuilderCityOptions: citiesForState
    });
};
onAddStagedRouteRow = () => {
    var state = this.state.routeBuilderState;
    var city = this.state.routeBuilderCity;
    var cityGrouping = this.state.routeBuilderCityGrouping;
    if (!state || !city || !cityGrouping) {
        this.setState({ basicTitle: "Please select State, City and City Grouping.", basicType: "warning", show: true });
        return;
    }
    var alreadyStaged = this.state.routeBuilderRows.some((r) =>
        (r.state || "").toUpperCase() === state.toUpperCase() &&
        (r.city || "").toUpperCase() === city.toUpperCase() &&
        (r.city_grouping || "").toUpperCase() === cityGrouping.toUpperCase()
    );
    if (alreadyStaged) {
        this.setState({ basicTitle: "This State / City / City Grouping combination is already added.", basicType: "warning", show: true });
        return;
    }
    var loading_port_code = this.state.loading_port_code;
    var consignees = this._consigneesCacheByPort[loading_port_code] || [];
    // getLmConsignees sorts by {_id:-1} on the backend, so the first match here
    // is already the latest record for this state/city/city_grouping combo.
    var match = consignees.find((c) =>
        (c.state || "").trim().toUpperCase() === state.toUpperCase() &&
        (c.city || "").trim().toUpperCase() === city.toUpperCase() &&
        (c.city_grouping || "").trim().toUpperCase() === cityGrouping.toUpperCase()
    );
    var newRow = {
        state: state, city: city, city_grouping: cityGrouping, zone: this.state.routeBuilderZone,
        lat: match ? match.lat : null, lng: match ? match.lng : null,
        tempKey: "new-" + state + "-" + city + "-" + cityGrouping + "-" + this.state.routeBuilderRows.length
    };
    var updatedRows = [...this.state.routeBuilderRows, newRow];
    this.setState({
        routeBuilderRows: updatedRows,
        routeBuilderState: "", routeBuilderCity: "", routeBuilderCityGrouping: "",
        routeBuilderCityOptions: this.state.routeBuilderDistinctCities,
        // A state (or its cities) can become fully used by this add - refresh
        // the State dropdown so it drops out once nothing's left under it.
        routeBuilderStateOptions: this.state.routeBuilderZone ? this.computeStateOptionsForZone(this.state.routeBuilderZone, updatedRows) : [],
        ...(match ? {} : { basicTitle: "Added, but no coordinates found in consignees for this combination - it won't show on the map.", basicType: "warning", show: true })
    });
};
onRemoveStagedRouteRow = (tempKey) => {
    var remainingRows = this.state.routeBuilderRows.filter((r) => r.tempKey !== tempKey);
    this.setState({
        routeBuilderRows: remainingRows,
        routeBuilderSelectedTempKeys: this.state.routeBuilderSelectedTempKeys.filter((k) => k !== tempKey),
        // Removing a row can free up a city (and in turn its state) that had
        // everything staged - refresh both dropdowns.
        ...(this.state.routeBuilderState ? { routeBuilderCityOptions: this.computeCityOptionsForState(this.state.routeBuilderState, remainingRows) } : {}),
        ...(this.state.routeBuilderZone ? { routeBuilderStateOptions: this.computeStateOptionsForZone(this.state.routeBuilderZone, remainingRows) } : {})
    });
};
onToggleStagedRowSelect = (tempKey) => {
    var selected = this.state.routeBuilderSelectedTempKeys;
    var isSelected = selected.indexOf(tempKey) !== -1;
    this.setState({
        routeBuilderSelectedTempKeys: isSelected
            ? selected.filter((k) => k !== tempKey)
            : [...selected, tempKey]
    });
};
onToggleSelectAllStagedRows = () => {
    var allTempKeys = this.state.routeBuilderRows.map((r) => r.tempKey);
    var allSelected = allTempKeys.length > 0 && allTempKeys.every((k) => this.state.routeBuilderSelectedTempKeys.indexOf(k) !== -1);
    this.setState({ routeBuilderSelectedTempKeys: allSelected ? [] : allTempKeys });
};
onBulkRemoveStagedRows = () => {
    var selected = this.state.routeBuilderSelectedTempKeys;
    var remainingRows = this.state.routeBuilderRows.filter((r) => selected.indexOf(r.tempKey) === -1);
    this.setState({
        routeBuilderRows: remainingRows,
        routeBuilderSelectedTempKeys: [],
        ...(this.state.routeBuilderState ? { routeBuilderCityOptions: this.computeCityOptionsForState(this.state.routeBuilderState, remainingRows) } : {}),
        ...(this.state.routeBuilderZone ? { routeBuilderStateOptions: this.computeStateOptionsForZone(this.state.routeBuilderZone, remainingRows) } : {})
    });
};
onSubmitRouteBuilder = async () => {
    var route = (this.state.routeBuilderRoute || "").trim();
    var rows = this.state.routeBuilderRows;
    if (!route) {
        this.setState({ basicTitle: "Please select a route.", basicType: "warning", show: true });
        return;
    }
    if (rows.length === 0) {
        this.setState({ basicTitle: "Please add at least one location.", basicType: "warning", show: true });
        return;
    }
    var originalIds = this.state.routeBuilderOriginalChildren.map((c) => c._id);
    var keptIds = rows.filter((r) => r._id).map((r) => r._id);
    var removedIds = originalIds.filter((id) => keptIds.indexOf(id) === -1);
    var newRows = rows.filter((r) => !r._id);

    if (this.state.routeBuilderMode === "edit") {
        // Zone lives on each row now (not one shared value for the batch), and a
        // kept row's zone can only change by being removed and re-added - so
        // removed/new rows already capture every real change here.
        var noChanges = route === (this.state.routeBuilderOriginalRoute || "").trim()
            && removedIds.length === 0
            && newRows.length === 0;
        if (noChanges) {
            this.setState({ basicTitle: "No changes found. Please modify at least one field before updating.", basicType: "warning", show: true });
            return;
        }
    }

    // ONE CITY -> ONE ZONE, checked BEFORE anything is posted.
    // Each staged row is saved by its own request, so letting the server reject one mid-flight
    // would leave the rest already written - a half-saved route. The server still enforces the
    // rule (it is the authority, and another user may have changed the grid since it loaded);
    // this is what keeps a rejection from landing in the middle of a batch.
    var zoneCompareKey = (v) => String(v || "").toUpperCase().replace(/\s+/g, "");
    var cityZoneOutsideThisRoute = {};
    this.state.rowData.forEach((r) => {
        if (originalIds.indexOf(r._id) !== -1) return;   // this route's own rows are being rewritten
        var ck = String(r.state || "").trim().toUpperCase() + "|" + String(r.city || "").trim().toUpperCase();
        if (cityZoneOutsideThisRoute[ck] === undefined) cityZoneOutsideThisRoute[ck] = String(r.zone || "").trim();
    });
    var stagedCityZone = {};
    var zoneClash = "";
    rows.forEach((row) => {
        if (zoneClash !== "") return;
        var ck = String(row.state || "").trim().toUpperCase() + "|" + String(row.city || "").trim().toUpperCase();
        var other = cityZoneOutsideThisRoute[ck];
        if (other !== undefined && zoneCompareKey(other) !== zoneCompareKey(row.zone)) {
            zoneClash = row.city + " is already configured in zone " + other
                + ", so it cannot also be placed in " + row.zone
                + ". A city can belong to only one zone.";
        } else if (stagedCityZone[ck] !== undefined && zoneCompareKey(stagedCityZone[ck]) !== zoneCompareKey(row.zone)) {
            zoneClash = row.city + " is staged twice here under different zones ("
                + stagedCityZone[ck] + " and " + row.zone + "). A city can belong to only one zone.";
        } else {
            stagedCityZone[ck] = row.zone;
        }
    });
    if (zoneClash !== "") {
        this.setState({ basicTitle: zoneClash, basicType: "warning", show: true });
        return;
    }

    this.setState({ routeBuilderSubmitting: true });
    var commonParams = {
        loading_port_code: this.state.loading_port_code,
        user_name: localStorage.getItem('username'),
        email: localStorage.getItem('email'),
        user_department: localStorage.getItem('lm_department'),
        staff_id: localStorage.getItem('staff_id'),
        designation: localStorage.getItem('designation'),
        comp_code: this.state.comp_code,
        user_role: localStorage.getItem('roles'),
        data_type: this.state.data_type,
    };
    try {
        var savePromises = rows.map((row) => redirectURL.post("/lmconsignees/savelmrouteconfig", {
            _id: row._id, state: row.state, city: row.city, city_grouping: row.city_grouping,
            route: route, zone: row.zone, ...commonParams
        }));
        var deletePromise = removedIds.length > 0
            ? redirectURL.post("/lmconsignees/deleteBulkLmRouteConfig", {
                rowIds: removedIds,
                comp_code: this.state.comp_code,
                user_name: localStorage.getItem('username'),
                email: localStorage.getItem('email'),
                user_department: localStorage.getItem('lm_department'),
                staff_id: localStorage.getItem('staff_id'),
                designation: localStorage.getItem('designation'),
                user_role: localStorage.getItem('roles'),
            })
            : Promise.resolve();
        await Promise.all([...savePromises, deletePromise]);
        this.setState({
            routeBuilderSubmitting: false,
            routeBuilderOpen: false,
            basicTitle: this.state.routeBuilderMode === "edit" ? "Updated Successfully." : "Added Successfully.",
            basicType: "success", show: true,
        });
        this.onLoadPageData();
    } catch (e) {
        console.log(e);
        // Surface the server's reason - it rejects a city placed in a second zone and an
        // already-existing combination, and a bare "Failed to save." hides both.
        var serverMessage = (e && e.response && e.response.data && e.response.data.message)
            ? e.response.data.message : "";
        this.setState({
            routeBuilderSubmitting: false,
            basicTitle: serverMessage || "Failed to save.",
            basicType: "warning", show: true
        });
        this.onLoadPageData();
    }
};
addNewRow()
{
    this.openRouteBuilder("add");
}
// Group-level actions (Actions column on the master/route rows).
handleEditRoute = (routeGroupData) => {
    this.openRouteBuilder("edit", routeGroupData);
};
handleDeleteRoute = (routeGroupData) => {
    this.onClickBulkDelete((routeGroupData.children || []).map((c) => c._id));
};
// Both loading ports and consignees are fetched once per port and cached on the
// instance (not state - they don't need to trigger re-renders), instead of hitting
// the full consignees list again on every single map click.
fetchConsigneesForMap = async (loading_port_code) => {
    if (this._consigneesCacheByPort[loading_port_code]) {
        return this._consigneesCacheByPort[loading_port_code];
    }
    var response = await redirectURL.post("/lmconsignees/getLmConsignees", { loading_port_code });
    var consignees = response.data || [];
    this._consigneesCacheByPort[loading_port_code] = consignees;
    return consignees;
};
fetchLoadingPortsForMap = async () => {
    if (this._loadingPortsCache) {
        return this._loadingPortsCache;
    }
    var response = await redirectURL.post("/lmconsignees/getLmLoadingPorts", {});
    var ports = response.data || [];
    this._loadingPortsCache = ports;
    return ports;
};
// Raw zone<->state master rows for this port (lmsobzones), cached the same way -
// this is the source of truth for which states belong to which zone, used both by
// the route builder's zone->state cascade and the bulk-upload cross-field checks.
fetchSobZonesForMap = async (loading_port_code) => {
    if (this._sobZonesCacheByPort[loading_port_code]) {
        return this._sobZonesCacheByPort[loading_port_code];
    }
    var response = await redirectURL.post("/lmconsignees/getLmSobZones", { loading_port_code });
    var rows = response.data || [];
    this._sobZonesCacheByPort[loading_port_code] = rows;
    return rows;
};
handleViewRouteMap = async (routeGroupData) => {
    var cities = (routeGroupData.cities || []).map((c) => (c || "").trim().toUpperCase());
    if (cities.length === 0) {
        this.setState({ basicTitle: "No cities found for this route.", basicType: "warning", show: true });
        return;
    }
    this.setState({ overly: "show-m", loadshow: "show-m" });
    try {
        // Two lookups, since neither lives on this screen's own rows:
        // - the warehouse (current loading port) location, from the loading ports master
        // - each city's lat/lng, from the same consignees data lmconsignees.js fetches
        var loading_port_code = this.state.loading_port_code;
        var [ports, consignees] = await Promise.all([
            this.fetchLoadingPortsForMap(),
            this.fetchConsigneesForMap(loading_port_code)
        ]);
        var portRecord = ports.find((p) => p.loading_port_code === loading_port_code);
        var warehouse = (portRecord && portRecord.lat && portRecord.lng)
            ? { lat: portRecord.lat, lng: portRecord.lng, label: loading_port_code, city: portRecord.city || "" }
            : null;

        var seen = {};
        var cityCoords = [];
        consignees.forEach((c) => {
            var cityUpper = (c.city || "").trim().toUpperCase();
            if (cities.indexOf(cityUpper) !== -1 && c.lat && c.lng && !seen[cityUpper]) {
                seen[cityUpper] = true;
                cityCoords.push({ lat: c.lat, lng: c.lng, city: c.city });
            }
        });

        this.setState({ overly: "show-n", loadshow: "show-n" });
        if (!warehouse && cityCoords.length === 0) {
            this.setState({ basicTitle: "No location data found for this route's warehouse or cities.", basicType: "warning", show: true });
            return;
        }
        this.setState({
            isMapOpen: true,
            routeMapWarehouse: warehouse,
            routeMapCities: cityCoords,
            // Header just names the route - the full city list is already the
            // grid's own column/tooltip, and each marker shows its city on click.
            routeMapHeaderTitle: "Route " + routeGroupData.route + " - Map View",
            routeMapWarehouseInfo: "<b>" + (warehouse && warehouse.city ? warehouse.city : "Warehouse") + "</b><br/>Loading Port: " + loading_port_code
        });
    } catch (e) {
        console.log(e);
        this.setState({ overly: "show-n", loadshow: "show-n", basicTitle: "Failed to load map data.", basicType: "warning", show: true });
    }
};
closeRouteMap = () => {
    this.setState({ isMapOpen: false, routeMapWarehouse: null, routeMapCities: [], routeMapHeaderTitle: "", routeMapWarehouseInfo: "" });
};
RouteActionRenderer = (props) => (
    <div className="d-flex justify-content-center align-items-center" style={{ gap: '6px', justifyContent: "center", width: "100%", height: "35px" }}>
        <Eye className="text-secondary cursor-pointer"
            size={15} style={{ cursor: "pointer" }} onClick={() => { props.node.setExpanded(!props.node.expanded); }} />
        <RouteIcon className="text-success cursor-pointer"
            size={15} style={{ cursor: "pointer" }} onClick={() => { this.handleViewRouteMap(props.data); }} />
        <Edit className="text-primary cursor-pointer"
            size={15} style={{ cursor: "pointer" }} onClick={() => { this.handleEditRoute(props.data); }} />
        <Trash className={this.state.isDeleting ? "text-muted" : "text-danger cursor-pointer"}
            size={15} style={{ cursor: this.state.isDeleting ? "not-allowed" : "pointer" }} onClick={() => { if (!this.state.isDeleting) this.handleDeleteRoute(props.data); }} />
    </div>
);
ZoneGroupInnerRenderer = (params) => (
    <span style={{ display: "flex", alignItems: "center", height: "100%", fontWeight: 600, color: "#1a237e" }}>
        {params.value}
    </span>
);
CountBadgeRenderer = (params) => (
    <span style={{
        display: "inline-block", minWidth: "28px", textAlign: "center",
        fontWeight: 600, color: "#1a237e",
        backgroundColor: "#e3f2fd", border: "1px solid #90caf9",
        borderRadius: "999px", padding: "3px 12px", fontSize: "12px"
    }}>
        {params.value}
    </span>
);
showGrid(){
    this.setState({
        showCalendar : "show-n",
        showGridData  : "show-m"
    })
}
onClickDataExport(){
    // gridApi.exportDataAsCsv() only sees the master (grouped) rows - each
    // route's state/city/city_grouping children live in their own per-row
    // detail grid, which ag-Grid's CSV export never reaches. Export the flat,
    // row-wise data directly instead, honoring the current Zone/State/City filters.
    var exportRows = this.state.rowData;
    var isAllZonesExport = !this.state.selectedZoneFilter;
    if(this.state.selectedZoneFilter)
    {
        exportRows = exportRows.filter((r) => (r.zone || "").toUpperCase() == this.state.selectedZoneFilter.toUpperCase());
    }
    if(this.state.selectedStateFilter && this.state.selectedStateFilter.length > 0)
    {
        var exportStatesUpper = this.state.selectedStateFilter.map((s) => s.toUpperCase());
        exportRows = exportRows.filter((r) => exportStatesUpper.indexOf((r.state || "").toUpperCase()) !== -1);
    }
    // Same "show the whole route, not just the selected city" behavior as the grid.
    exportRows = this.expandRowsToFullRoutesForCityFilter(exportRows, isAllZonesExport, this.state.selectedCityFilter);
    var sheetData = exportRows.map((r) => ({
        "Route": r.route || "",
        "Zone": r.zone || "",
        "State": r.state || "",
        "City": r.city || "",
        "City Grouping": r.city_grouping || "",
    }));
    var worksheet = XLSX.utils.json_to_sheet(sheetData);
    var workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Route Configurations");
    XLSX.writeFile(workbook, "route_configurations.csv");
}
onClickBulkDelete(array){
    if (this.state.isDeleting) return;
    var rowIds = array || [];
    console.log(rowIds,"rowIds")
    if(rowIds.length > 0)
    {
        var qry = {
            rowIds:rowIds,
            comp_code: this.state.comp_code,
            user_name: localStorage.getItem('username'),
            email: localStorage.getItem('email'),
            user_department: localStorage.getItem('lm_department'),
            staff_id: localStorage.getItem('staff_id'),
            designation: localStorage.getItem('designation'),
            user_role: localStorage.getItem('roles'),
        }
        // Same in-app dialog as every other message on this screen, instead of the browser's
        // own "<host> says" box. Called both from the grid's bulk-delete button and from a
        // route row's Delete action (which passes that whole route's child rows), so the count
        // is what tells the user which of the two they are about to do.
        this.askConfirm({
            title : rowIds.length > 1
                ? "Delete " + rowIds.length + " route configuration records?"
                : "Delete this route configuration?",
            message : "A consignee city left with no route row is dropped as \"No Route Info\".",
            confirmText : "Yes, delete",
            onConfirm : () => {
            this.setState({ isDeleting: true, loadshow: "show-m", overly: "show-m" });
            redirectURL.post("/lmconsignees/deleteBulkLmRouteConfig",qry).then((response)=>{
                console.log(response.data);
                if(response.data.message == "Success")
                {
                    this.setState({
                        basicTitle:"Deleted Successfully.",
                        basicType : "success",
                        show : true,
                        rowIds : [],
                        selectedRows : [],
                        isDeleting: false,
                        loadshow: "show-n",
                        overly: "show-n",
                    })
                    //window.location.reload();
                    this.onLoadPageData();
                }
                else
                {
                    this.setState({
                        basicTitle:"Failed to Delete.",
                        basicType : "warning",
                        show : true,
                        isDeleting: false,
                        loadshow: "show-n",
                        overly: "show-n",
                    })
                }
            }).catch((e)=>{
                console.log(e);
                this.setState({ isDeleting: false, loadshow: "show-n", overly: "show-n" });
            })
            }
        });
    }
    else
    {
        this.setState({
            basicTitle:"Please select the Row(s) to continue.",
            basicType : "warning",
            show : true
        })
    }
}
showBulkUpload(){
    this.setState({
        overly :"show-m",
        bulkslide : "slider-translate",
        errors: [],
        validData: [],
        fileName: ""
    })
}
handleFileChange = (e) => {
    const file = e.target.files[0];
    e.target.value = ""; // reset immediately

    if (!file) return;
    this.setState({ fileName: file.name })

    const reader = new FileReader();
    reader.readAsArrayBuffer(file);

    reader.onload = (event) => {
        const workbook = XLSX.read(
            new Uint8Array(event.target.result),
            { type: "array" }
        );
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });
        this.validateExcelData(data);
    };
};
validateExcelData = async (data) => {
    let errorList = [];
    let cleanedData = [];

    const validStates = this.state.statesList.map((each) => String(each).toUpperCase());
    const validZones = this.state.zonesList.filter(z => z !== "").map((each) => String(each).toUpperCase());
    const validRoutes = this.state.routesList.map((each) => String(each).toUpperCase());

    var loading_port_code = this.state.loading_port_code;
    var loading_port_label = (this.state.lpNames.find((p) => p.loading_port_code === loading_port_code) || {}).label || loading_port_code;
    var [consignees, sobZones] = await Promise.all([
        this.fetchConsigneesForMap(loading_port_code),
        this.fetchSobZonesForMap(loading_port_code)
    ]);

    // Which states each zone actually covers, per this port's SOB zone master -
    // catches a row where the Zone/State pairing doesn't really exist.
    var zoneToStates = {};
    sobZones.forEach((r) => {
        var zn = (r.zone || "").trim().toUpperCase();
        var st = (r.state || "").trim().toUpperCase();
        if (!zn || !st) return;
        if (!zoneToStates[zn]) zoneToStates[zn] = [];
        if (zoneToStates[zn].indexOf(st) === -1) zoneToStates[zn].push(st);
    });

    // Which cities, and which city_groupings per city, this port's consignees
    // actually have - catches a City not under that State, or a City Grouping
    // that isn't really used by that City, both scoped to this loading port.
    var stateToCities = {};
    var cityGroupingsByStateCity = {};
    var validCityGroups = [];
    consignees.forEach((c) => {
        var st = (c.state || "").trim().toUpperCase();
        var ct = (c.city || "").trim().toUpperCase();
        var cg = (c.city_grouping || "").trim().toUpperCase();
        if (st && ct) {
            if (!stateToCities[st]) stateToCities[st] = [];
            if (stateToCities[st].indexOf(ct) === -1) stateToCities[st].push(ct);
        }
        if (st && ct && cg) {
            var key = st + "|" + ct;
            if (!cityGroupingsByStateCity[key]) cityGroupingsByStateCity[key] = [];
            if (cityGroupingsByStateCity[key].indexOf(cg) === -1) cityGroupingsByStateCity[key].push(cg);
        }
        if (cg && validCityGroups.indexOf(cg) === -1) validCityGroups.push(cg);
    });
    var validCities = Object.keys(stateToCities).reduce((all, st) => all.concat(stateToCities[st]), []);

    // State, City, City Grouping, Zone and Route together make a row unique -
    // the same 5-field combo shouldn't be uploaded twice in one file. When it
    // repeats, the LAST occurrence wins (kept as valid); earlier ones are
    // flagged as duplicates and skipped.
    var lastIndexForLocationKey = {};
    data.forEach((row, idx) => {
        var st = String(getCellValue(row, "State") || "").trim().toUpperCase();
        var ct = String(getCellValue(row, "City") || "").trim().toUpperCase();
        var cg = String(getCellValue(row, "City Grouping") || getCellValue(row, "city_grouping") || "").trim().toUpperCase();
        var zn = String(getCellValue(row, "Zone") || "").trim().toUpperCase();
        var rt = String(getCellValue(row, "Route") || "").replace(/\s+/g, "").toUpperCase();
        if (st && ct && cg && zn && rt) {
            lastIndexForLocationKey[st + "|" + ct + "|" + cg + "|" + zn + "|" + rt] = idx;
        }
    });

    // The in-file duplicate check above only catches a combo repeated within
    // THIS upload - it has no idea a combo already sits in the grid (loaded
    // from the DB, this.state.rowData) from an earlier upload, which is exactly
    // how the same record kept getting re-inserted as a fresh duplicate row.
    var existingLocationKeys = {};
    this.state.rowData.forEach((r) => {
        var key = (r.state || "").trim().toUpperCase() + "|" + (r.city || "").trim().toUpperCase() + "|"
            + (r.city_grouping || "").trim().toUpperCase() + "|" + (r.zone || "").trim().toUpperCase() + "|"
            + (r.route || "").trim().toUpperCase();
        existingLocationKeys[key] = true;
    });

    // ONE CITY -> ONE ZONE. The duplicate key above carries the ZONE, so the same city under a
    // DIFFERENT zone was never a duplicate and uploaded cleanly. The planning engine reads
    // these rows as a { (state, city): zone } dict that overrides the state-level SOB zone, and
    // it builds a consignee's allowed routes on state+city+city_grouping with NO zone - so a
    // city owning two zones both makes its zone unpredictable AND hands the solver the union of
    // both zones' routes, whose route numbers repeat across zones.
    // Spaces are stripped when comparing, matching how the engine normalizes a route-config
    // zone, so "DELHI NCR" and "DELHINCR" are correctly one zone and never a false conflict.
    var zoneCompareKey = (v) => String(v || "").toUpperCase().replace(/\s+/g, "");
    var cityZoneInGrid = {};
    this.state.rowData.forEach((r) => {
        var ck = (r.state || "").trim().toUpperCase() + "|" + (r.city || "").trim().toUpperCase();
        if (cityZoneInGrid[ck] === undefined) cityZoneInGrid[ck] = String(r.zone || "").trim();
    });
    var cityZoneInFile = {};
    data.forEach((row) => {
        var st = String(getCellValue(row, "State") || "").trim().toUpperCase();
        var ct = String(getCellValue(row, "City") || "").trim().toUpperCase();
        var zn = String(getCellValue(row, "Zone") || "").trim();
        if (!st || !ct || !zn) return;
        var ck = st + "|" + ct;
        if (cityZoneInFile[ck] === undefined) cityZoneInFile[ck] = [];
        if (cityZoneInFile[ck].map(zoneCompareKey).indexOf(zoneCompareKey(zn)) === -1) {
            cityZoneInFile[ck].push(zn);
        }
    });

    data.forEach((row, index) => {
        const rowNumber = index + 2;

        let state = String(getCellValue(row, "State") || "").trim();
        let city = String(getCellValue(row, "City") || "").trim();
        let cityGrouping = String(getCellValue(row, "City Grouping") || getCellValue(row, "city_grouping") || "").trim();
        let zone = String(getCellValue(row, "Zone") || "").trim();
        // Spaces anywhere in the Route cell ("route 1", "ROUTE 1") are stripped
        // entirely, not just trimmed - so it still resolves to ROUTE1 instead of
        // being rejected as an invalid route.
        let route = String(getCellValue(row, "Route") || "").replace(/\s+/g, "");

        let rowErrors = [];
        let stateValid = false;
        let cityValid = false;

        if (!state) {
            rowErrors.push("State is required");
        } else if (!validStates.includes(state.toUpperCase())) {
            rowErrors.push(`State "${state}" is invalid`);
        } else {
            stateValid = true;
        }

        if (!city) {
            rowErrors.push("City is required");
        } else if (!validCities.includes(city.toUpperCase())) {
            rowErrors.push(`City "${city}" is not valid for this warehouse(${loading_port_label})`);
        } else if (stateValid && (stateToCities[state.toUpperCase()] || []).indexOf(city.toUpperCase()) === -1) {
            rowErrors.push(`City "${city}" does not belong to State "${state}" for this warehouse(${loading_port_label})`);
        } else {
            cityValid = true;
        }

        if (!cityGrouping) {
            rowErrors.push("City Grouping is required");
        } else if (!validCityGroups.includes(cityGrouping.toUpperCase())) {
            rowErrors.push(`City Grouping "${cityGrouping}" is not valid for this warehouse(${loading_port_label})`);
        } else if (stateValid && cityValid) {
            var groupingsForCity = cityGroupingsByStateCity[state.toUpperCase() + "|" + city.toUpperCase()] || [];
            if (groupingsForCity.indexOf(cityGrouping.toUpperCase()) === -1) {
                rowErrors.push(`City Grouping "${cityGrouping}" does not belong to City "${city}" for this warehouse(${loading_port_label})`);
            }
        }

        if (!zone) {
            rowErrors.push("Zone is required");
        } else if (!validZones.includes(zone.toUpperCase())) {
            rowErrors.push(`Zone "${zone}" is invalid`);
        } else if (stateValid && (zoneToStates[zone.toUpperCase()] || []).indexOf(state.toUpperCase()) === -1) {
            rowErrors.push(`Zone "${zone}" does not belong to State "${state}" for this warehouse(${loading_port_label})`);
        } else if (cityValid) {
            // ONE CITY -> ONE ZONE, against the grid and against this same file.
            var cityKey = state.toUpperCase() + "|" + city.toUpperCase();
            var gridZone = cityZoneInGrid[cityKey];
            var fileZones = cityZoneInFile[cityKey] || [];
            if (gridZone !== undefined && zoneCompareKey(gridZone) !== zoneCompareKey(zone)) {
                rowErrors.push(`City "${city}" is already configured in Zone "${gridZone}" - a city can belong to only one zone, so Zone "${zone}" cannot be used for it`);
            } else if (fileZones.length > 1) {
                rowErrors.push(`City "${city}" appears in this file under more than one zone (${fileZones.join(", ")}) - a city can belong to only one zone`);
            }
        }

        if (!route) {
            rowErrors.push("Route is required");
        } else if (!validRoutes.includes(route.toUpperCase())) {
            rowErrors.push(`Route "${route}" is invalid`);
        }

        if (state && city && cityGrouping && zone && route) {
            var locationKey = state.toUpperCase() + "|" + city.toUpperCase() + "|" + cityGrouping.toUpperCase() + "|" + zone.toUpperCase() + "|" + route.toUpperCase();
            if (lastIndexForLocationKey[locationKey] !== index) {
                rowErrors.push(`State "${state}" / City "${city}" / City Grouping "${cityGrouping}" / Zone "${zone}" / Route "${route}" is duplicated in this file - row ${lastIndexForLocationKey[locationKey] + 2} (the last occurrence) is uploaded instead`);
            } else if (existingLocationKeys[locationKey]) {
                rowErrors.push(`State "${state}" / City "${city}" / City Grouping "${cityGrouping}" / Zone "${zone}" / Route "${route}" already exists in the grid - edit the existing record instead of re-uploading it`);
            }
        }

        if (rowErrors.length > 0) {
            errorList.push({
                row: rowNumber,
                errors: rowErrors
            });
        } else {
            // Validation above matches case-insensitively (route.toUpperCase() against
            // validRoutes, etc.), but storing the raw typed casing would let
            // "route1"/"Route1"/"ROUTE1" all pass as "valid" while landing in the DB as
            // different strings - fragmenting what should be one route/zone/city into
            // separate grid groups. Normalize to the same canonical uppercase form the
            // valid-value lists already use.
            cleanedData.push({
                state: state.toUpperCase(),
                city: city.toUpperCase(),
                city_grouping: cityGrouping.toUpperCase(),
                zone: zone.toUpperCase(),
                route: route.toUpperCase()
            });
        }
    });

    if (cleanedData.length === 0 && errorList.length === 0) {
        errorList.push({
            row: "",
            errors: ["No data found. All rows are empty"]
        });
    }

    this.setState({
        errors: errorList,
        validData: cleanedData
    });

    console.log("Valid Data:", cleanedData);
    console.log("Errors:", errorList);
};
handleBulkUpload = async () => {
    try {
        this.setState({
            loadshow: "show-m",
            overly: "show-m",
            bulkUploadSubmitting: true,
        })

        var reqParams = {
            csvData: this.state.validData,
            loading_port_code: this.state.loading_port_code,
            user_name: localStorage.getItem('username'),
            email: localStorage.getItem('email'),
            staff_id: localStorage.getItem('staff_id'),
            user_department: localStorage.getItem('lm_department'),
            designation: localStorage.getItem('designation'),
            comp_code: this.state.comp_code,
            user_role: localStorage.getItem('roles'),
            data_type: this.state.data_type,
        }
        const response = await redirectURL.post("/lmconsignees/savebulklmrouteconfig", reqParams);
        await this.onLoadPageData();
        this.setState({
            basicTitle: response.data.message,
            basicType: "success",
            show: true,
            loadshow: "show-n",
            overly: "show-n",
            bulkUploadSubmitting: false,
            bulkslide: "",
            errors: [],
            validData: [],
            fileName: "",
        })
        if (this.fileInputRef.current) {
            this.fileInputRef.current.value = "";
        }
    } catch (err) {
        console.error(err);
        this.setState({
            loadshow: "show-n",
            overly: "show-n",
            bulkUploadSubmitting: false,
        })
    }
};
getShortFileName = (name, maxLength = 31) => {
    const lastDot = name.lastIndexOf(".");
    const baseName = name.substring(0, lastDot);
    const extension = name.substring(lastDot);

    if (baseName.length <= maxLength) return name;

    return baseName.substring(0, maxLength) + "..." + extension;
};

onRowSelection(event){
    var rowIds=[];
    var rwCount = event.api.getSelectedNodes();
    rwCount.map((item) => {
        rowIds.push(item.data._id)
    });

    this.setState({
        rowIds:rowIds
    })
}
// ---------------- Zone (inline, applies immediately - not part of the popup) ----------------
onZoneFilterChange = (selectedOption) => {
    var zone = selectedOption ? selectedOption.value : "";
    // Changing Zone can invalidate whatever State/City were picked before it -
    // rebuild both option lists scoped to the new zone, keeping any selections
    // that are still valid and auto-picking either one if narrowed to a single
    // remaining value.
    var stateOptions = this.computeDistinctStates(this.state.rowData, zone);
    var validStates = this.state.selectedStateFilter.filter((s) => stateOptions.indexOf(s) !== -1);
    var selectedState = validStates.length > 0 ? validStates : this.pickMultiDefault(stateOptions);
    var cityOptions = this.computeDistinctCities(this.state.rowData, zone, selectedState);
    var validCities = this.state.selectedCityFilter.filter((c) => cityOptions.indexOf(c) !== -1);
    var selectedCity = validCities.length > 0 ? validCities : this.pickMultiDefault(cityOptions);
    this.setState({
        selectedZoneFilter: zone,
        selectedStateFilter: selectedState,
        selectedCityFilter: selectedCity,
        stateFilterOptions: stateOptions.map((v) => ({ label: v, value: v })),
        cityFilterOptions: cityOptions.map((v) => ({ label: v, value: v })),
    });
};

// ---------------- Filters popup (Apply/Cancel) - State/City only ----------------
openFilterPopup = () => {
    this.setState({
        filterPopupOpen: true,
        draftStateFilter: this.state.selectedStateFilter,
        draftCityFilter: this.state.selectedCityFilter,
        draftStateOptions: this.state.stateFilterOptions,
        draftCityOptions: this.state.cityFilterOptions,
    });
};
closeFilterPopup = () => {
    // Cancel - just close, the draftX fields are thrown away untouched and
    // the already-applied selectedXFilter/xFilterOptions are never read here.
    this.setState({ filterPopupOpen: false });
};
onDraftStateFilterChange = (selectedOptions) => {
    var states = (selectedOptions || []).map((o) => o.value);
    // Changing State can invalidate whatever cities were picked before it -
    // rebuild city options (still scoped to whichever Zone is applied) auto-
    // picking one if narrowed down to a single remaining value.
    var cityOptions = this.computeDistinctCities(this.state.rowData, this.state.selectedZoneFilter, states);
    var selectedCity = this.pickMultiDefault(cityOptions);
    this.setState({
        draftStateFilter: states,
        draftCityFilter: selectedCity,
        draftCityOptions: cityOptions.map((v) => ({ label: v, value: v })),
    });
};
onDraftCityFilterChange = (selectedOptions) => {
    this.setState({ draftCityFilter: (selectedOptions || []).map((o) => o.value) });
};
applyFilterPopup = () => {
    this.setState({
        selectedStateFilter: this.state.draftStateFilter,
        selectedCityFilter: this.state.draftCityFilter,
        stateFilterOptions: this.state.draftStateOptions,
        cityFilterOptions: this.state.draftCityOptions,
        filterPopupOpen: false,
    });
};
// Narrow the grid to one conflicting city so every route carrying it - in BOTH zones - is
// visible together and the wrong-zone rows can be deleted. Drives the screen's own
// zone/state/city filter rather than an ag-grid column filter, because the grid's master rows
// are route GROUPS, not city rows, so a column filter would not reach the cities at all.
//   - zone is reset to All Zones on purpose: groups are keyed zone+route only in that mode, so
//     the same city under two zones shows as two separate route groups, which is the point.
//   - expandRowsToFullRoutesForCityFilter then pulls in each route's other cities, so a route
//     is shown whole instead of collapsing to the one city that was picked.
// The existing "Applied:" chips render the selection with their own remove buttons, so this
// needs no clear link of its own.
filterGridToCity = (state, city) => {
    var stateOptions = this.computeDistinctStates(this.state.rowData, "");
    var cityOptions = this.computeDistinctCities(this.state.rowData, "", [state]);
    this.setState({
        selectedZoneFilter: "",
        selectedStateFilter: [state],
        selectedCityFilter: [city],
        stateFilterOptions: stateOptions.map((v) => ({ label: v, value: v })),
        cityFilterOptions: cityOptions.map((v) => ({ label: v, value: v })),
        draftStateFilter: [state],
        draftCityFilter: [city],
        draftStateOptions: stateOptions.map((v) => ({ label: v, value: v })),
        draftCityOptions: cityOptions.map((v) => ({ label: v, value: v })),
    });
};
clearAppliedFilters = () => {
    var stateOptions = this.computeDistinctStates(this.state.rowData, this.state.selectedZoneFilter);
    var cityOptions = this.computeDistinctCities(this.state.rowData, this.state.selectedZoneFilter, []);
    this.setState({
        selectedStateFilter: [],
        selectedCityFilter: [],
        stateFilterOptions: stateOptions.map((v) => ({ label: v, value: v })),
        cityFilterOptions: cityOptions.map((v) => ({ label: v, value: v })),
    });
};
// Drops just this one state from the multi-select, leaving Zone/City and
// every other selected state untouched - backs each state chip's own remove
// button. City options/selection are re-scoped since removing a state can
// invalidate a city that only belonged to it.
removeStateFilterValue = (state) => {
    var remainingStates = this.state.selectedStateFilter.filter((s) => s !== state);
    var cityOptions = this.computeDistinctCities(this.state.rowData, this.state.selectedZoneFilter, remainingStates);
    var remainingCities = this.state.selectedCityFilter.filter((c) => cityOptions.indexOf(c) !== -1);
    this.setState({
        selectedStateFilter: remainingStates,
        selectedCityFilter: remainingCities,
        cityFilterOptions: cityOptions.map((v) => ({ label: v, value: v })),
    });
};
// Drops just this one city from the multi-select, leaving State and every
// other selected city untouched - backs each city chip's own remove button.
removeCityFilterValue = (city) => {
    this.setState({ selectedCityFilter: this.state.selectedCityFilter.filter((c) => c !== city) });
};
onRouteGroupOpened = () => {
    if (this.state.selectedRowsApi) {
        try { this.state.selectedRowsApi.deselectAll(); } catch (e) { console.log(e); }
    }
    this.setState({ selectedRows: [], selectedRowsApi: null });
};

componentDidUpdate() {
    if (this.context && this.context.loading_port_code !== this._lastLoadingPortCode) {
        this._lastLoadingPortCode = this.context.loading_port_code;
        this.onGlobalPortChange();
    }
}
onGlobalPortChange = async () => {
    var selectedPlant = this.context.loading_port_code;
    if (!selectedPlant || !this.state.lpNames.some(each => each.loading_port_code == selectedPlant)) {
        // Not a valid port for this screen - keep this screen's own selection, don't refetch.
        return;
    }
    await this.pageAccess();
}
async onClickTab(data_type)
{
    var regularActive = "";
    var truckActive = "";
    var courierActive = "";
    if(data_type == 1)
    {
        regularActive = "activet";
    }
    else if(data_type == 2)
    {
        truckActive = "activet";
    }
    else
    {
        courierActive = "activet";
    }
    // Switching tabs loads a whole new set of rows - any selection made on the
    // previous tab's grid no longer corresponds to anything real, so it has to
    // be cleared here too, not just left for the grid to sort out on its own.
    if (this.state.selectedRowsApi) {
        try { this.state.selectedRowsApi.deselectAll(); } catch (e) { console.log(e); }
    }
    await this.setState({
        data_type : data_type,
        regularActive : regularActive,
        truckActive : truckActive,
        courierActive : courierActive,
        selectedZoneFilter : "",
        selectedStateFilter : [],
        selectedCityFilter : [],
        selectedRows : [],
        selectedRowsApi : null,
    });
    await this.onLoadPageData();
}
  render() {
    var multiZoneCities = this.getMultiZoneCities();
    // Detail/sub-grid (the "View" drill-down) is read-only by design - no checkbox,
    // no edit/delete here. Those actions now live only on the master Route row.
    var columnwithDefs = [
        {
            headerName: "State",
            field: "state",
            width:180,
            flex: 1,
            filter: true,
            resizable: true,
        },
        {
            headerName: "City",
            field: "city",
            width:180,
            flex: 1,
            filter: true,
            resizable: true,
        },
        {
            headerName: "City Grouping",
            field: "city_grouping",
            width:180,
            flex: 1,
            filter: true,
            resizable: true,
        },
        {
            headerName: "Zone",
            field: "zone",
            width:200,
            flex: 1,
            filter: true,
            resizable: true,
        },
    ]
    // Sourced from the SOB Zones API (zonesList, fetched in fetchZones and
    // kept in sync in onLoadPageData) - same source the Route Builder's own
    // Zone dropdown uses, so both stay consistent instead of this one being
    // limited to whatever zones happen to already be saved in route-config rows.
    var zoneFilterOptions = this.toFilterOptions(this.state.zonesList, "All Zones");
    // Small transparent-chip look for the always-visible inline Zone pill -
    // distinct from the light, roomier styling the popup's own dropdowns use.
    var inlineZoneSelectStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: "28px",
            fontSize: "13px",
            backgroundColor: "transparent",
            border: "none",
            boxShadow: "none",
            cursor: "pointer"
        }),
        singleValue: (provided) => ({ ...provided, color: "#263238", fontWeight: 600 }),
        placeholder: (provided) => ({ ...provided, color: "#263238", fontWeight: 600 }),
        input: (provided) => ({ ...provided, color: "#263238" }),
        valueContainer: (provided) => ({ ...provided, padding: "0px 4px" }),
        indicatorsContainer: (provided) => ({ ...provided, height: "28px" }),
        dropdownIndicator: (provided) => ({ ...provided, padding: "4px", color: "#1976d2", cursor: "pointer" }),
        clearIndicator: (provided) => ({ ...provided, padding: "4px", color: "#546e7a", cursor: "pointer" }),
        menuPortal: (provided) => ({ ...provided, zIndex: 3000 })
    };
    // Light, airy look for the Filters popup's own dropdowns - distinct from
    // the small pill styling the inline Zone filter uses.
    var filterPopupSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            borderRadius: "8px",
            borderColor: state.isFocused ? "#90caf9" : "#dde7f2",
            boxShadow: state.isFocused ? "0 0 0 3px rgba(33,150,243,0.12)" : "none",
            backgroundColor: "#fff",
            minHeight: "38px"
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: "#e3f2fd",
            borderRadius: "6px"
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: "#0d47a1",
            fontWeight: 600,
            fontSize: "12px"
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: "#1976d2"
        }),
        placeholder: (provided) => ({ ...provided, color: "#90a4ae", fontSize: "13px" }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? "#1976d2" : state.isFocused ? "#e3f2fd" : "#fff",
            color: state.isSelected ? "#fff" : "#37474f"
        }),
        // The popup itself clips to rounded corners with overflow:hidden, which
        // would also clip these menus - render them in a portal on <body> so
        // they float above everything instead of getting cut off by that.
        menuPortal: (provided) => ({ ...provided, zIndex: 3000 })
    };
    // Shown as removable chips in a strip above the grid for whatever's
    // actually applied right now. Zone is deliberately left out here - it's
    // already visible inline as its own always-shown dropdown, so a chip for
    // it would just be a redundant second display of the same selection.
    var appliedFilterChips = [];
    (this.state.selectedStateFilter || []).forEach((state) => {
        appliedFilterChips.push({ key: "state-" + state, tone: "#ede7f6", text: "#4527a0", border: "#d1c4e9", label: "State: " + state, onRemove: () => this.removeStateFilterValue(state) });
    });
    (this.state.selectedCityFilter || []).forEach((city) => {
        appliedFilterChips.push({ key: "city-" + city, tone: "#e0f2f1", text: "#00695c", border: "#b2dfdb", label: "City: " + city, onRemove: () => this.removeCityFilterValue(city) });
    });
    var appliedFilterCount = appliedFilterChips.length; // drives the Filters button's count badge
    var filteredRouteRows = this.state.rowData;
    var isAllZones = !this.state.selectedZoneFilter;
    if(!isAllZones)
    {
        filteredRouteRows = filteredRouteRows.filter((r) => (r.zone || "").toUpperCase() == this.state.selectedZoneFilter.toUpperCase());
    }
    if(this.state.selectedStateFilter && this.state.selectedStateFilter.length > 0)
    {
        var filterStatesUpper = this.state.selectedStateFilter.map((s) => s.toUpperCase());
        filteredRouteRows = filteredRouteRows.filter((r) => filterStatesUpper.indexOf((r.state || "").toUpperCase()) !== -1);
    }
    // Show every city on the same route as any selected city, not just the
    // selected city's own row - otherwise picking one city fragments its route
    // down to a single-city "group" instead of showing the whole route.
    filteredRouteRows = this.expandRowsToFullRoutesForCityFilter(filteredRouteRows, isAllZones, this.state.selectedCityFilter);
    // The same route name can exist under more than one zone - group by
    // zone + route together so those don't get blended into a single row.
    var groupedRouteData = Object.values(
        filteredRouteRows.reduce((acc, item) => {
            var key = isAllZones ? ((item.zone || "") + "___" + (item.route || "")) : (item.route || "");
            if (!acc[key]) {
                acc[key] = { route: item.route, zone: item.zone, cities: [], count: 0, children: [] };
            }
            acc[key].children.push(item);
            acc[key].count += 1;
            if (item.city && acc[key].cities.indexOf(item.city) === -1) {
                acc[key].cities.push(item.city);
            }
            return acc;
        }, {})
    );
    groupedRouteData.forEach((g) => { g.cityLocations = g.cities.join(", "); g.locationCount = g.cities.length; });
    // Plain string sort would put "ROUTE10" before "ROUTE2" - compare the numeric
    // part of the route name so ROUTE1 < ROUTE2 < ... < ROUTE9 < ROUTE10 properly.
    // With All Zones selected, sort by zone first so routes don't interleave
    // across zones.
    groupedRouteData.sort((a, b) => {
        if (isAllZones) {
            var aZone = a.zone || "";
            var bZone = b.zone || "";
            if (aZone !== bZone) return aZone.localeCompare(bZone);
        }
        var aRoute = a.route || "";
        var bRoute = b.route || "";
        var aNum = parseInt(aRoute.replace(/[^0-9]/g, ""), 10);
        var bNum = parseInt(bRoute.replace(/[^0-9]/g, ""), 10);
        if (!isNaN(aNum) && !isNaN(bNum) && aNum !== bNum) {
            return aNum - bNum;
        }
        return aRoute.localeCompare(bRoute);
    });
    var groupColumnDefs = [
        {
            headerName: "",
            field: "actions",
            width: 140,
            pinned: 'left',
            filter: false,
            resizable: true,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            cellRenderer: "routeActionRenderer",
        },
        {
            // Plain column now - no expand chevron/click here, the Eye icon in
            // Actions is the only way to open the sub-grid.
            headerName: "Route",
            field: "route",
            width: 140,
            flex: 1,
            filter: true,
            resizable: true,
        },
        // Only relevant with "All Zones" selected - a specific zone filter already
        // implies every visible row belongs to that one zone.
        ...(isAllZones ? [{
            headerName: "Zone",
            field: "zone",
            width: 140,
            flex: 1, 
            filter: true,
            resizable: true,
        }] : []), 
        {
            headerName: "No of Locations",
            field: "locationCount",
            flex: 1,
            minWidth: 180,
            filter: true,
            resizable: true,
            tooltipField: "cityLocations",
        },
    ];
    var routeGridOptions = {
        context: { componentParent: this },
        masterDetail: true,
        columnDefs: groupColumnDefs,
        defaultColDef: {
            sortable: true,
            filter: true,
            floatingFilter: true,
            resizable: true,
        },
        // Selection now happens on the master (Route) rows - the sub-grid is
        // read-only - so the toolbar bulk Delete flattens each selected route's
        // children into their _ids (see the Delete button in the header below).
        onSelectionChanged: (params) => {
            this.setState({ selectedRows: params.api.getSelectedRows(), selectedRowsApi: params.api });
        },
        getDetailRowHeight: () => 320,
        detailCellRendererParams: {
            detailGridOptions: {
                columnDefs: columnwithDefs,
                defaultColDef: {
                    sortable: true,
                    filter: true,
                    resizable: true,
                },
                frameworkComponents: this.state.frameworkComponents,
                rowSelection: "multiple",
                suppressRowClickSelection: true,
                rowHeight: 45,
                headerHeight: 45,
                onSelectionChanged: (params) => {
                    this.setState({ selectedRows: params.api.getSelectedRows(), selectedRowsApi: params.api });
                },
            },
            getDetailRowData: (params) => {
                params.successCallback(params.data.children);
            },
        },
    };
    var userroles = localStorage.getItem("roles")
    return (
      <div class="container-fluid" style={{height: "100%"}}>
        {/* Default ag-grid tooltip has poor contrast and no max-width - the City
            Locations column's comma-separated list would otherwise stretch across
            the whole screen and be hard to read. */}
        <style>{`
            .ag-theme-balham .ag-tooltip, .ag-tooltip{
                max-width: 320px !important;
                white-space: normal !important;
                word-break: break-word !important;
                background: #ffffff !important;
                color: #263238 !important;
                padding: 8px 10px !important;
                border: 1px solid #d3d9de !important;
                border-radius: 6px !important;
                font-size: 12px !important;
                line-height: 1.4 !important;
                box-shadow: 0 2px 8px rgba(0,0,0,0.15) !important;
            }
        `}</style>
        <SweetAlert
            show={this.state.show}
            type={this.state.basicType}
            title={this.state.basicTitle}
            onConfirm={this.closeAlert}
        >
        </SweetAlert>

        {/* Confirmation dialog - same component the success/failure messages use, so an
            "are you sure" reads like the rest of the app instead of the browser's own
            "<host> says" box. Kept separate from the alert above because that one's
            onConfirm reloads the grid. */}
        <SweetAlert
            show={this.state.confirmAlert.open}
            type={this.state.confirmAlert.type}
            title={this.state.confirmAlert.title}
            showCancel
            confirmBtnText={this.state.confirmAlert.confirmText}
            cancelBtnText="Cancel"
            confirmBtnBsStyle="primary"
            cancelBtnBsStyle="default"
            onConfirm={this.onConfirmAccepted}
            onCancel={this.closeConfirm}
        >
            {this.state.confirmAlert.message}
        </SweetAlert>

        {/* {(this.state.loading_port_code == "GUR") ? */}
        <div className="row col-sm-12" style={{marginBottom:"10px"}}>
            <ul
                style={{
                    display: "inline-flex",
                    flexWrap: "wrap",      // prevents cutting
                    padding: "4px",
                    margin: 0,
                    listStyle: "none",
                    gap: "4px",
                    backgroundColor: "#ffffff",
                    borderRadius: "10px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.15)"
                }}
            >
                {[
                    { onClick: () => this.onClickTab(1), label: "Regular", active: this.state.regularActive },
                    { onClick: () => this.onClickTab(3), label: "Dedicated", active: this.state.courierActive },
                    { onClick: () => this.onClickTab(2), label: "Surface Courier", active: this.state.truckActive },
                ].map(({ onClick, label, active }, idx) => {
                    var isActive = active == "activet";
                    return (
                        <li key={idx} onClick={onClick} style={{ listStyle: "none" }}>
                            <button
                                type="button"
                                style={{
                                    whiteSpace: "nowrap",
                                    border: "none",
                                    outline: "none",
                                    borderRadius: "999px",
                                    padding: "8px 18px",
                                    fontSize: "13px",
                                    fontWeight: isActive ? 600 : 500,
                                    cursor: "pointer",
                                    transition: "all 0.2s ease",
                                    backgroundColor: isActive ? "#1976d2" : "transparent",
                                    color: isActive ? "#fff" : "#555",
                                    boxShadow: isActive ? "0 1px 4px rgba(25,118,210,0.4)" : "none"
                                }}
                            >
                                {label}
                            </button>
                        </li>
                    );
                })}
            </ul>
        </div>
        {/* // :""} */}
        <div className="card col-xl-12 d-flex flex-column" style={{height: "90%", borderRadius: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)"}}>
            <div className="d-flex justify-content-between align-items-center" style={{flexWrap: "wrap", gap: "10px", padding: "14px 18px", marginBottom: "10px", flexShrink: 0}}>
                <div className="d-flex align-items-center" style={{gap: "14px"}}>
                    <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                    <h5 style={{margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px"}}>Route Configurations</h5>
                </div>
                <div className="d-flex align-items-center" style={{flexWrap: "wrap", gap: "8px"}}>
                    {(this.state.pageAccess == 3 && this.state.selectedRows.length > 0) ?
                    <button className="pill-btn pill-btn-danger" disabled={this.state.isDeleting} style={{ cursor: this.state.isDeleting ? "not-allowed" : "pointer", opacity: this.state.isDeleting ? 0.5 : 1 }} onClick={() => { this.onClickBulkDelete(this.state.selectedRows.flatMap((group) => (group.children || []).map((c) => c._id))) }}>Delete</button>
                    : ""}
                    {this.state.rowData.length > 0 && (
                        <div className="d-flex align-items-center" style={{
                            backgroundColor: "#efefef", borderRadius: "999px",
                            padding: "4px 6px 4px 14px", gap: "4px"
                        }}>
                            <span style={{ fontSize: "13px", fontWeight: 600, color: "#546e7a", whiteSpace: "nowrap" }}>Zone :</span>
                            <div style={{ width: "150px" }}>
                                <Select
                                    options={zoneFilterOptions}
                                    value={zoneFilterOptions.find((z) => z.value === this.state.selectedZoneFilter) || null}
                                    onChange={this.onZoneFilterChange}
                                    placeholder="Select Zone"
                                    styles={inlineZoneSelectStyles}
                                    menuPortalTarget={document.body}
                                />
                            </div>
                        </div>
                    )}
                    {this.state.rowData.length > 0 && (
                        <button className="pill-btn pill-btn-soft pill-btn-info" onClick={this.openFilterPopup}>
                            <FilterIcon size={14} />
                            Filters
                            {appliedFilterCount > 0 && (
                                <span style={{
                                    backgroundColor: "#1976d2", color: "#fff", borderRadius: "999px",
                                    fontSize: "11px", fontWeight: 700, padding: "1px 7px", minWidth: "16px", textAlign: "center"
                                }}>{appliedFilterCount}</span>
                            )}
                        </button>
                    )}
                    <button className="pill-btn pill-btn-primary" onClick={this.onClickDataExport.bind(this)}>Export Data</button>
                    {(this.state.pageAccess != 2) ?
                    <button className="pill-btn pill-btn-info" onClick={this.showBulkUpload.bind(this)}>Import Data</button>
                    : ""}
                    {(this.state.pageAccess != 2) ?
                    <button className="pill-btn pill-btn-success" onClick={this.addNewRow.bind(this)}>Add Route</button>
                    : ""}
                </div>
            </div>
            {appliedFilterCount > 0 && (
                <div style={{
                    display: "flex", alignItems: "center", flexWrap: "wrap", gap: "8px",
                    padding: "10px 18px", margin: "0 18px 12px", flexShrink: 0,
                    background: "#f4f8fd", border: "1px solid #e3edf9", borderRadius: "10px"
                }}>
                    <span style={{ display: "inline-flex", alignItems: "center", gap: "5px", fontSize: "12px", fontWeight: 700, color: "#5c7a9e" }}>
                        <FilterIcon size={12} /> Applied:
                    </span>
                    {appliedFilterChips.map((chip) => (
                        <span key={chip.key} style={{
                            display: "inline-flex", alignItems: "center", gap: "5px",
                            backgroundColor: chip.tone, color: chip.text, border: "1px solid " + chip.border,
                            borderRadius: "999px", padding: "3px 8px 3px 12px", fontSize: "12px", fontWeight: 600,
                            lineHeight: "16px", whiteSpace: "nowrap"
                        }}>
                            {chip.label}
                            <span
                                onClick={chip.onRemove}
                                title="Remove filter"
                                style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", opacity: 0.75 }}
                            >
                                <XIcon size={11} />
                            </span>
                        </span>
                    ))}
                    {appliedFilterCount > 1 && (
                        <span
                            onClick={this.clearAppliedFilters}
                            style={{ fontSize: "12px", fontWeight: 600, color: "#1976d2", cursor: "pointer", textDecoration: "underline", whiteSpace: "nowrap", marginLeft: "2px" }}
                        >
                            Clear all
                        </span>
                    )}
                </div>
            )}
            <div className="card-body col-xl-12 col-lg-12" style={{padding: "10px 12px 10px 12px", width: "100%", flex: "1 1 0%", minHeight: 0, display: "flex", flexDirection: "column"}}>
                <style>{`
                    .route-group-grid .ag-row:not(.ag-row-level-1) {
                        cursor: pointer;
                    }
                    .route-group-grid .ag-row:not(.ag-row-level-1):hover {
                        background-color: #e3f2fd !important;
                    }
                    .route-group-grid .ag-group-expanded .ag-icon,
                    .route-group-grid .ag-group-contracted .ag-icon {
                        color: #1976d2;
                        font-size: 16px;
                    }
                    .route-group-grid .ag-cell-wrapper {
                        height: 100%;
                        display: flex;
                        align-items: center;
                    }
                `}</style>
                {(multiZoneCities.length > 0) ?
                <div style={{ background: "#fdecea", border: "1px solid #f5c2c0", borderRadius: "6px", padding: "10px 14px", marginBottom: "6px", fontSize: "13px", color: "#8a1c13", flexShrink: 0 }}>
                    <strong>{multiZoneCities.length} {multiZoneCities.length === 1 ? "city is" : "cities are"} configured under more than one zone.</strong>{" "}
                    {this.state.multiZoneOpen ? (
                        <>
                            That is supported - a city can serve NCR routes and also appear on upcountry routes.
                            Each consignee of such a city should carry a Zone on the Consignee master so it is
                            planned on the right side; without it the consignee plans in its state's Default
                            zone (set on SOB Zones). Click a city to see the routes carrying it:
                            <ul style={{ margin: "6px 0 0 0", paddingLeft: "18px" }}>
                                {multiZoneCities.map((each) => (
                                    <li key={each.key}>
                                        <a href="#/" onClick={(ev) => { ev.preventDefault(); this.filterGridToCity(each.state, each.city); }}
                                           style={{ color: "#8a1c13", fontWeight: 700, textDecoration: "underline" }}>
                                            {each.state} / {each.city}
                                        </a>
                                        {" "}&rarr; {each.zones.join(" , ")}
                                    </li>
                                ))}
                            </ul>
                            <a href="#/" onClick={(ev) => { ev.preventDefault(); this.setState({ multiZoneOpen: false }); }}
                               style={{ color: "#1565c0", fontWeight: 600, display: "inline-block", marginTop: "4px" }}>
                                Show less
                            </a>
                        </>
                    ) : (
                        <>
                            Supported, but each consignee there should carry a Zone on the Consignee master.{" "}
                            <a href="#/" onClick={(ev) => { ev.preventDefault(); this.setState({ multiZoneOpen: true }); }}
                               style={{ color: "#1565c0", fontWeight: 600 }}>
                                Show more
                            </a>
                        </>
                    )}
                </div>
                : ""}
                <div className="ag-theme-balham grid-wrapper route-group-grid" style={{flex: 1, minHeight: 0}}>
                <AgGridReact
                    ref={this.gridRef}
                    modules={this.state.modules}
                    frameworkComponents={this.state.frameworkComponents}
                    defaultColDef={{
                        sortable: true,
                        filter: true,
                        floatingFilter: true, resizable: true
                    }}
                    rowData={groupedRouteData}
                    rowSelection={this.state.rowSelection}
                    enableCharts={false}
                    onGridReady={this.onGridReady}
                    onGridState={this.onGridState}
                    statusBar={this.state.statusBar}
                    sideBar={this.state.sideBar}
                    stopEditingWhenGridLosesFocus= {true}
                    paginationPageSize={this.state.paginationPageSize}
                    pagination={true}
                    gridOptions={routeGridOptions}
                    animateRows
                    rowHeight={45}
                    headerHeight={45}
                    onRowGroupOpened={this.onRouteGroupOpened}
                    suppressRowClickSelection={true}
                    />
            </div>
            </div>
        </div>

        {this.state.filterPopupOpen && (
            <>
                <div className="slider-overlay" onClick={this.closeFilterPopup} />
                <div style={{
                    position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
                    width: "620px", maxWidth: "94vw", background: "#fff", borderRadius: "14px",
                    boxShadow: "0 12px 40px rgba(30,60,110,0.22)", zIndex: 1002, overflow: "hidden"
                }}>
                    <div style={{
                        display: "flex", justifyContent: "space-between", alignItems: "center",
                        padding: "16px 20px", background: "linear-gradient(135deg,#eaf3fe,#f5f9ff)",
                        borderBottom: "1px solid #e3edf9"
                    }}>
                        <span style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "15px", fontWeight: 700, color: "#1a237e" }}>
                            <FilterIcon size={16} /> Filters
                        </span>
                        <span
                            onClick={this.closeFilterPopup}
                            style={{
                                cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center",
                                width: "26px", height: "26px", borderRadius: "50%", color: "#5c7a9e",
                                backgroundColor: "rgba(255,255,255,0.7)"
                            }}
                        >
                            <XIcon size={14} />
                        </span>
                    </div>
                    <div style={{ padding: "20px", background: "#fbfcfe", display: "flex", flexDirection: "column", gap: "16px" }}>
                        <div>
                            <div style={{ fontSize: "11px", fontWeight: 700, color: "#78909c", marginBottom: "6px", textTransform: "uppercase", letterSpacing: "0.4px" }}>State</div>
                            <Select
                                isMulti
                                options={this.state.draftStateOptions}
                                value={this.state.draftStateOptions.filter((s) => this.state.draftStateFilter.indexOf(s.value) !== -1)}
                                onChange={this.onDraftStateFilterChange}
                                placeholder="All States"
                                styles={filterPopupSelectStyles}
                                menuPortalTarget={document.body}
                            />
                        </div>
                        <div>
                            <div style={{ fontSize: "11px", fontWeight: 700, color: "#78909c", marginBottom: "6px", textTransform: "uppercase", letterSpacing: "0.4px" }}>City</div>
                            <Select
                                isMulti
                                options={this.state.draftCityOptions}
                                value={this.state.draftCityOptions.filter((c) => this.state.draftCityFilter.indexOf(c.value) !== -1)}
                                onChange={this.onDraftCityFilterChange}
                                placeholder="All Cities"
                                styles={filterPopupSelectStyles}
                                menuPortalTarget={document.body}
                            />
                        </div>
                    </div>
                    <div style={{
                        display: "flex", justifyContent: "flex-end", gap: "10px",
                        padding: "14px 20px", background: "#f3f6fa", borderTop: "1px solid #e3edf9"
                    }}>
                        <button
                            onClick={this.closeFilterPopup}
                            style={{
                                border: "1px solid #cfd8e3", background: "#fff", color: "#546e7a",
                                borderRadius: "999px", padding: "7px 18px", fontSize: "13px", fontWeight: 600, cursor: "pointer"
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={this.applyFilterPopup}
                            style={{
                                border: "none", background: "#1976d2", color: "#fff",
                                borderRadius: "999px", padding: "7px 20px", fontSize: "13px", fontWeight: 600, cursor: "pointer",
                                boxShadow: "0 2px 8px rgba(25,118,210,0.35)"
                            }}
                        >
                            Apply
                        </button>
                    </div>
                </div>
            </>
        )}

        <div className={`hub-slider ${this.state.bulkslide ? "open" : ""} d-flex flex-column`}>

            {this.state.bulkUploadSubmitting && (
                <div style={{ position: "absolute", inset: 0, background: "rgba(255,255,255,0.7)", zIndex: 10, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div style={{ fontSize: "13px", fontWeight: 600, color: "#003e67" }}>Uploading...</div>
                </div>
            )}
            <div className="slider-header">
                Import Data
                <span onClick={() => { if (!this.state.bulkUploadSubmitting) this.onClickHideAll(); }} style={{ cursor: this.state.bulkUploadSubmitting ? "not-allowed" : "pointer" }}>✕</span>
            </div>

            <div className="slider-body flex-grow-1 d-flex flex-column" style={{ minHeight: "0px" }}>

                <input
                    ref={this.fileInputRef}
                    type="file"
                    accept=".xlsx,.xls,.csv"
                    onChange={this.handleFileChange}
                    disabled={this.state.bulkUploadSubmitting}
                    style={{ display: "none" }}
                />
                <div className="d-flex align-items-center gap-3">
                    <button
                        className="btn btn-info d-flex justify-content-center p-3"
                        type="button"
                        onClick={() => this.fileInputRef.current.click()}
                        disabled={this.state.bulkUploadSubmitting}
                    >
                        Upload File
                    </button>

                    <a href={require('../../assets/json/sample_lmroute_config.csv')} className="btn btn-secondary d-flex justify-content-center ml-3 p-3 flex-grow-1">
                        Download Sample Template
                    </a>
                </div>
                <div style={{ marginTop: "10px", fontSize: "12px", color: "#c62828", fontWeight: 600 }}>
                    Note: Route is a mandatory column - select a route between {this.state.routesList[0]} - {this.state.routesList[this.state.routesList.length - 1]} for every row.
                </div>

                {this.state.fileName && (
                    <div style={{ marginTop: "15px", display: "flex", gap: "6px", maxWidth: "410px" }}>
                        <span>Selected File :</span>
                        <span
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                flex: 1,
                                fontWeight: "bold"
                            }}
                            title={this.state.fileName}
                        >
                            {this.getShortFileName(this.state.fileName)}
                        </span>
                    </div>
                )}

                {this.state.errors.length > 0 && (
                    <>
                        <h6 className="text-danger mt-3">Validation Errors ({this.state.errors.length} row{this.state.errors.length > 1 ? "s" : ""})</h6>

                        <div style={{ flexGrow: 1, overflowY: "auto", width: "100%" }}>
                            <table className="table-bordered mb-0 err-table" style={{ width: "100%", positive: "relative" }}>
                                <thead className="table-light text-center" style={{ positive: "sticky", zIndex: "100", backgroundColor: "#efefef" }}>
                                    <tr>
                                        <th style={{ width: "60px", padding: "9px 15px" }}>Row</th>
                                        <th>Error Description</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {this.state.errors.map((err, i) => (
                                        <tr key={i}>
                                            <td className="text-center" style={{ padding: "9px 15px" }}>
                                                {err.row}
                                            </td>

                                            <td style={{ padding: "9px 15px", wordBreak: "break-word" }}>
                                                {err.errors.map((e, idx) => (
                                                    <p className="m-0" key={idx}>{e}</p>
                                                ))}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}

            </div>
            <div className="slider-footer">
                <button
                    className="save-btn" style={{ margin: "0px", width: "auto", padding: "5px 25px", cursor: (this.state.validData.length == 0 || this.state.bulkUploadSubmitting) && "not-allowed", opacity: (this.state.validData.length == 0 || this.state.bulkUploadSubmitting) && "0.5" }}
                    onClick={this.handleBulkUpload}
                    disabled={this.state.validData.length == 0 || this.state.bulkUploadSubmitting}
                >
                    {(this.state.errors.length > 0 && this.state.validData.length > 0) ? "Submit only valid data" : "Submit"}
                </button>
            </div>

        </div>
        {this.state.routeBuilderOpen && (
            <>
                <div className="slider-overlay" onClick={() => { if (!this.state.routeBuilderSubmitting) this.closeRouteBuilder(); }} />
                <div style={{ position: "fixed", top: 0, right: 0, width: "96%", maxWidth: "1100px", height: "100%", background: "#fff", zIndex: 1002, boxShadow: "-4px 0 12px rgba(0,0,0,0.2)", display: "flex", flexDirection: "column" }}>
                    {this.state.routeBuilderSubmitting && (
                        <div style={{ position: "absolute", inset: 0, background: "rgba(255,255,255,0.7)", zIndex: 10, display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <div style={{ fontSize: "13px", fontWeight: 600, color: "#003e67" }}>Saving...</div>
                        </div>
                    )}
                    <div className="slider-header">
                        <span>{this.state.routeBuilderMode === "edit" ? "Edit Route Configuration" : "Add Route Configuration"}</span>
                        <span onClick={() => { if (!this.state.routeBuilderSubmitting) this.closeRouteBuilder(); }} style={{ cursor: this.state.routeBuilderSubmitting ? "not-allowed" : "pointer" }}>✕</span>
                    </div>
                    <div style={{ flex: "1 1 auto", minHeight: 0, display: "flex" }}>
                        <div style={{ width: "55%", padding: "16px", borderRight: "1px solid #e0e0e0", display: "flex", flexDirection: "column", minHeight: 0 }}>
                            <div className="d-flex" style={{ gap: "10px", marginBottom: "14px", flex: "0 0 auto" }}>
                                <div style={{ flex: 1 }}>
                                    <label style={{ fontSize: "12px", fontWeight: 600, color: "#546e7a" }}>Zone <span className="text-danger">*</span></label>
                                    <Select
                                        options={this.state.zonesList.map((each) => ({ label: each, value: each }))}
                                        value={this.state.routeBuilderZone ? { label: this.state.routeBuilderZone, value: this.state.routeBuilderZone } : null}
                                        onChange={this.onRouteBuilderZoneChange}
                                        placeholder="Select Zone"
                                        menuPlacement="auto"
                                        menuPortalTarget={document.body}
                                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
                                        isDisabled={this.state.routeBuilderMode === "edit" || this.state.routeBuilderRows.length > 0}
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <label style={{ fontSize: "12px", fontWeight: 600, color: "#546e7a" }}>Route <span className="text-danger">*</span></label>
                                    {/* Options are the ROUTE1-ROUTE50 slots that don't already have a saved
                                        row under the picked zone - a route already created for this zone can
                                        only be reached (and edited) via that row's own Edit action, never from
                                        here, so it's never offered as a choice in Add mode. */}
                                    <Select
                                        options={this.state.routeBuilderRouteOptions.map((each) => ({ label: each, value: each }))}
                                        value={this.state.routeBuilderRoute ? { label: this.state.routeBuilderRoute, value: this.state.routeBuilderRoute } : null}
                                        onChange={(sel) => { this.setState({ routeBuilderRoute: sel ? sel.value : "" }); }}
                                        placeholder={
                                            this.state.routeBuilderMode !== "edit" && !this.state.routeBuilderZone ? "Select Zone first" :
                                            this.state.routeBuilderMode !== "edit" && this.state.routeBuilderRouteOptions.length === 0 ? "No routes available for this zone" :
                                            "Select Route"
                                        }
                                        noOptionsMessage={() => "No routes available for this zone"}
                                        menuPlacement="auto"
                                        menuPortalTarget={document.body}
                                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
                                        isDisabled={this.state.routeBuilderMode === "edit" || this.state.routeBuilderRows.length > 0 || !this.state.routeBuilderZone}
                                    />
                                </div>
                            </div>
                            <div style={{ background: "#f5f7f9", borderRadius: "8px", padding: "12px", marginBottom: "14px", flex: "0 0 auto" }}>
                                {(!this.state.routeBuilderRoute || !this.state.routeBuilderZone) && (
                                    <div style={{ fontSize: "12px", color: "#90a4ae", marginBottom: "8px" }}>Select Zone and Route first</div>
                                )}
                                <div className="d-flex" style={{ gap: "8px", marginBottom: "8px" }}>
                                    <div style={{ flex: 1 }}>
                                        <label style={{ fontSize: "12px", fontWeight: 600, color: "#546e7a" }}>State <span className="text-danger">*</span></label>
                                        <Select
                                            options={this.state.routeBuilderStateOptions.map((each) => ({ label: each, value: each }))}
                                            value={this.state.routeBuilderState ? { label: this.state.routeBuilderState, value: this.state.routeBuilderState } : null}
                                            onChange={this.onRouteBuilderStateChange}
                                            placeholder="State"
                                            menuPlacement="auto"
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
                                            isDisabled={!this.state.routeBuilderRoute || !this.state.routeBuilderZone}
                                        />
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <label style={{ fontSize: "12px", fontWeight: 600, color: "#546e7a" }}>City <span className="text-danger">*</span></label>
                                        <Select
                                            options={this.state.routeBuilderCityOptions.map((each) => ({ label: each, value: each }))}
                                            value={this.state.routeBuilderCity ? { label: this.state.routeBuilderCity, value: this.state.routeBuilderCity } : null}
                                            onChange={(sel) => { this.setState({ routeBuilderCity: sel ? sel.value : "" }); }}
                                            placeholder="City"
                                            menuPlacement="auto"
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
                                            isDisabled={!this.state.routeBuilderRoute || !this.state.routeBuilderZone || !this.state.routeBuilderState}
                                        />
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <label style={{ fontSize: "12px", fontWeight: 600, color: "#546e7a" }}>City Grouping <span className="text-danger">*</span></label>
                                        <Select
                                            options={this.state.routeBuilderDistinctCityGroupings.map((each) => ({ label: each, value: each }))}
                                            value={this.state.routeBuilderCityGrouping ? { label: this.state.routeBuilderCityGrouping, value: this.state.routeBuilderCityGrouping } : null}
                                            onChange={(sel) => { this.setState({ routeBuilderCityGrouping: sel ? sel.value : "" }); }}
                                            placeholder="City Grouping"
                                            menuPlacement="auto"
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
                                            isDisabled={!this.state.routeBuilderRoute || !this.state.routeBuilderZone}
                                        />
                                    </div>
                                </div>
                                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <button
                                        onClick={this.onAddStagedRouteRow}
                                        disabled={!this.state.routeBuilderRoute || !this.state.routeBuilderZone}
                                        style={{
                                            border: "none", borderRadius: "5px", padding: "5px 12px",
                                            fontSize: "12px", fontWeight: 500,
                                            cursor: (!this.state.routeBuilderRoute || !this.state.routeBuilderZone) ? "not-allowed" : "pointer",
                                            opacity: (!this.state.routeBuilderRoute || !this.state.routeBuilderZone) ? 0.5 : 1,
                                            background: "#00897b", color: "#fff"
                                        }}
                                    >+ Add to List</button>
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between" style={{ marginBottom: "6px", flex: "0 0 auto" }}>
                                <div style={{ fontSize: "12px", fontWeight: 600, color: "#546e7a" }}>
                                    Staged Locations ({this.state.routeBuilderRows.length})
                                </div>
                                {this.state.routeBuilderSelectedTempKeys.length > 0 && (
                                    <button
                                        onClick={this.onBulkRemoveStagedRows}
                                        style={{
                                            border: "none", borderRadius: "5px", padding: "4px 10px",
                                            fontSize: "12px", fontWeight: 500, cursor: "pointer",
                                            background: "#d32f2f", color: "#fff"
                                        }}
                                    >Delete Selected ({this.state.routeBuilderSelectedTempKeys.length})</button>
                                )}
                            </div>
                            <div style={{ border: "1px solid #e0e0e0", borderRadius: "6px", flex: "1 1 auto", minHeight: 0, overflowY: "auto", position: "relative" }}>
                                {this.state.routeBuilderRows.length === 0 ? (
                                    <div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center", color: "#90a4ae", fontSize: "12px" }}>
                                        No locations added yet.
                                    </div>
                                ) : (
                                    <table style={{ width: "100%", fontSize: "12px", borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr style={{ background: "#f5f7f9" }}>
                                                <th style={{ padding: "6px 8px", width: "26px", position: "sticky", top: 0, background: "#f5f7f9" }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={this.state.routeBuilderRows.length > 0 && this.state.routeBuilderRows.every((r) => this.state.routeBuilderSelectedTempKeys.indexOf(r.tempKey) !== -1)}
                                                        onChange={this.onToggleSelectAllStagedRows}
                                                    />
                                                </th>
                                                <th style={{ padding: "6px 8px", textAlign: "left", position: "sticky", top: 0, background: "#f5f7f9" }}>State</th>
                                                <th style={{ padding: "6px 8px", textAlign: "left", position: "sticky", top: 0, background: "#f5f7f9" }}>City</th>
                                                <th style={{ padding: "6px 8px", textAlign: "left", position: "sticky", top: 0, background: "#f5f7f9" }}>City Grouping</th>
                                                <th style={{ padding: "6px 8px", textAlign: "left", position: "sticky", top: 0, background: "#f5f7f9" }}>Zone</th>
                                                <th style={{ padding: "6px 8px", width: "36px", position: "sticky", top: 0, background: "#f5f7f9" }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.routeBuilderRows.map((row) => (
                                                <tr key={row.tempKey} style={{ borderTop: "1px solid #eceff1" }}>
                                                    <td style={{ padding: "6px 8px", textAlign: "center" }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={this.state.routeBuilderSelectedTempKeys.indexOf(row.tempKey) !== -1}
                                                            onChange={() => { this.onToggleStagedRowSelect(row.tempKey); }}
                                                        />
                                                    </td>
                                                    <td style={{ padding: "6px 8px" }}>{row.state}</td>
                                                    <td style={{ padding: "6px 8px" }}>{row.city}</td>
                                                    <td style={{ padding: "6px 8px" }}>{row.city_grouping}</td>
                                                    <td style={{ padding: "6px 8px" }}>{row.zone}</td>
                                                    <td style={{ padding: "6px 8px", textAlign: "center" }}>
                                                        <Trash className="text-danger cursor-pointer" size={13} style={{ cursor: "pointer" }} onClick={() => { this.onRemoveStagedRouteRow(row.tempKey); }} />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                        <div style={{ width: "45%", minHeight: 0 }}>
                            <RouteMapPopup
                                warehouse={this.state.routeBuilderWarehouse}
                                cities={this.state.routeBuilderRows.filter((r) => r.lat && r.lng).map((r) => ({ lat: r.lat, lng: r.lng, city: r.city }))}
                                routeInfoHtml={"<b>" + (this.state.routeBuilderWarehouse && this.state.routeBuilderWarehouse.city ? this.state.routeBuilderWarehouse.city : "Warehouse") + "</b><br/>Loading Port: " + this.state.loading_port_code}
                            />
                        </div>
                    </div>
                    <div className="slider-footer">
                        <button
                            onClick={this.closeRouteBuilder}
                            disabled={this.state.routeBuilderSubmitting}
                            style={{
                                border: "1px solid #cfd8dc", borderRadius: "999px", padding: "8px 18px",
                                fontSize: "13px", fontWeight: 500, cursor: this.state.routeBuilderSubmitting ? "not-allowed" : "pointer",
                                background: "#eceff1", color: "#37474f", marginRight: "8px",
                                opacity: this.state.routeBuilderSubmitting ? 0.6 : 1
                            }}
                        >Cancel</button>
                        <button className="save-btn" style={{ margin: "0px", opacity: this.state.routeBuilderSubmitting ? 0.6 : 1, cursor: this.state.routeBuilderSubmitting ? "not-allowed" : "pointer" }} disabled={this.state.routeBuilderSubmitting} onClick={this.onSubmitRouteBuilder}>Submit</button>
                    </div>
                </div>
            </>
        )}
        {this.state.isMapOpen && (
            <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div style={{ background: "#fff", width: "96%", maxWidth: "1000px", height: "90vh", borderRadius: "10px", overflow: "hidden", display: "flex", flexDirection: "column" }}>
                    <div style={{ flex: "0 0 auto", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", borderBottom: "1px solid #e0e0e0", background: "#003e67", color: "#fff" }}>
                        <span style={{ fontSize: "14px", fontWeight: 600 }}>{this.state.routeMapHeaderTitle || "Route Map"}</span>
                        <span onClick={this.closeRouteMap} style={{ cursor: "pointer", background: "#fff", color: "#003e67", borderRadius: "50%", width: "26px", height: "26px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginLeft: "12px" }}>✕</span>
                    </div>
                    <div style={{ flex: "1 1 auto", minHeight: 0 }}>
                        <RouteMapPopup
                            warehouse={this.state.routeMapWarehouse}
                            cities={this.state.routeMapCities}
                            routeInfoHtml={this.state.routeMapWarehouseInfo}
                        />
                    </div>
                </div>
            </div>
        )}
        <div className={"dataLoadpage " +(this.state.loadshow)}>
        </div>
        <div className={"dataLoadpageimg " +(this.state.loadshow)}>
            <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
        </div>
        <div className={"overlay-part "+(this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
      </div>

    );
  }
}

function dateComparator1(date1,date2){
	//console.log(date1,date2);
	if(date1 != "" && date2 != "" && date1 != undefined && date2 != undefined ){
		// console.log(date1,date2);
	var date_1 = getMonthNumber(date1.split("-")[1]);
	date1 = date1.replace(date1.split("-")[1],date_1);
	var date_2 = getMonthNumber(date2.split("-")[1]);
	date2 = date2.replace(date2.split("-")[1],date_2);
	var date1Number = monthToComparableNumber1(date1);
	var date2Number = monthToComparableNumber1(date2);
	if (date1Number === null && date2Number === null) {
	  return 0;
	}
	if (date1Number === null) {
	  return -1;
	}
	if (date2Number === null) {
	  return 1;
	}
	return date1Number - date2Number;
	}	
}

function monthToComparableNumber1(date) {
	console.log(date.length);
	console.log(date);
	if (date === undefined || date === null || date.length !== 10) {
		return null;
	}
	var yearNumber = date.substring(6, 10);
	var monthNumber = date.substring(3, 5);
	var dayNumber = date.substring(0, 2);
	var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
	return result;
}
function dateComparator(date1, date2) {
	// console.log("dateComparator");
	// console.log(date1.length);
	if(date1 != "" && date2 != "" && date1 != undefined && date2 != undefined ){
		// console.log(date1,date2);
	var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
	date1 = date1.replace(date1.split(" ")[0].split("-")[1],date_1);
	var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
	date2 = date2.replace(date2.split(" ")[0].split("-")[1],date_2);
	// console.log(date1,date2);
	var date1Number = monthToComparableNumber(date1);
	var date2Number = monthToComparableNumber(date2);
	// console.log(date1Number,date2Number);
	if (date1Number === null && date2Number === null) {
	  return 0;
	}
	if (date1Number === null) {
	  return -1;
	}
	if (date2Number === null) {
	  return 1;
	}
	return date1Number - date2Number;
	}
  }
function monthToComparableNumber(date) {
	// console.log(date,date.length);
	if (date === undefined || date === null || date.length !== 16) {
		return null;
	}
	var yearNumber = date.substring(6, 10);
	var monthNumber = date.substring(3, 5);
	var dayNumber = date.substring(0, 2);
	console.log(yearNumber,monthNumber,dayNumber);
	var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
	return result;
}

function getMonthNumber(monthName){
	var months = [
		'Jan', 'Feb', 'Mar', 'Apr', 'May',
		'Jun', 'Jul', 'Aug', 'Sep',
		'Oct', 'Nov', 'Dec'
		];
	var monthNum = months.indexOf(monthName)+1;
	if(monthNum < 10){
		monthNum = "0"+monthNum.toString();
	}
	return monthNum;
}


// Small, self-contained map for the route "view on map" popup - built fresh rather
// than reusing the shared DrawMap components (those assume one homogenous marker
// set with shared info-window content; this needs a distinct warehouse marker with
// its own click popup versus plain city markers, and no route line yet - that's a
// later addition once real route-path data exists).
const ROUTE_MAP_WAREHOUSE_ICON = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(
	'<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24">' +
	'<path fill="#1a237e" stroke="#ffffff" stroke-width="0.6" d="M12 2 2 8v12h20V8L12 2zm7 16H5V9.5l7-4.2 7 4.2V18z"/>' +
	'<path fill="#1a237e" d="M8 12h3v6H8zM13 12h3v6h-3z"/>' +
	'</svg>'
);
// Google's InfoWindow chrome (the bubble padding and the "x" close button) can't
// be styled through the marker/content HTML - it renders in its own gm-style-iw-*
// wrapper outside our React tree, so this has to be a global override, injected
// once regardless of how many maps mount.
function ensureRouteMapInfoWindowStyles(){
	if(document.getElementById('routeMapInfoWindowStyles')) return;
	var style = document.createElement('style');
	style.id = 'routeMapInfoWindowStyles';
	style.innerHTML = `
		.gm-style-iw-c {
			padding: 0 !important;
			border-radius: 8px !important;
		}
		.gm-style-iw-d {
			overflow: auto !important;
			padding: 0 !important;
		}
		.gm-style-iw-t button.gm-ui-hover-effect {
			top: 4px !important;
			right: 4px !important;
			opacity: 0.8;
		}
		.gm-style-iw-t button.gm-ui-hover-effect img {
			width: 14px !important;
			height: 14px !important;
			margin: 0 !important;
		}
	`;
	document.head.appendChild(style);
}
function routeMapInfoWindowHtml(innerHtml){
	return '<div style="padding:10px 30px 10px 12px; font-family:inherit; font-size:13px; ' +
		'color:#263238; line-height:1.5; max-width:220px;">' + innerHtml + '</div>';
}
class RouteMapPopup extends Component {
	componentDidMount(){
		this.ensureGoogleMapsLoaded(this.renderMap);
	}
	componentDidUpdate(prevProps){
		if(prevProps.warehouse !== this.props.warehouse || prevProps.cities !== this.props.cities){
			this.ensureGoogleMapsLoaded(this.renderMap);
		}
	}
	ensureGoogleMapsLoaded = (cb) => {
		if(window.google && window.google.maps){ cb(); return; }
		if(window.__routeMapScriptLoading){
			var check = setInterval(() => {
				if(window.google && window.google.maps){ clearInterval(check); cb(); }
			}, 200);
			return;
		}
		window.__routeMapScriptLoading = true;
		var script = document.createElement('script');
		script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCbVLHDKmRETk7xp5RZzUdMYPCZe7Is59w&libraries=places";
		script.async = true;
		script.onload = () => { window.__routeMapScriptLoading = false; cb(); };
		document.body.appendChild(script);
	};
	renderMap = () => {
		var el = document.getElementById('routeMapPopupCanvas');
		if(!el || !window.google) return;
		ensureRouteMapInfoWindowStyles();
		var warehouse = this.props.warehouse;
		var cities = this.props.cities || [];
		var fallbackCenter = { lat: 28.4519751, lng: 77.0310713 };
		var center = warehouse
			? { lat: parseFloat(warehouse.lat), lng: parseFloat(warehouse.lng) }
			: (cities[0] ? { lat: parseFloat(cities[0].lat), lng: parseFloat(cities[0].lng) } : fallbackCenter);
		var map = new window.google.maps.Map(el, {
			zoom: 8,
			center: center,
			mapTypeId: window.google.maps.MapTypeId.ROADMAP
		});
		var bounds = new window.google.maps.LatLngBounds();

		if(warehouse){
			var whLatLng = new window.google.maps.LatLng(parseFloat(warehouse.lat), parseFloat(warehouse.lng));
			bounds.extend(whLatLng);
			var whMarker = new window.google.maps.Marker({
				position: whLatLng,
				map: map,
				icon: { url: ROUTE_MAP_WAREHOUSE_ICON, scaledSize: new window.google.maps.Size(34, 34) },
				title: warehouse.label || "Warehouse",
				zIndex: 999
			});
			var whInfoWindow = new window.google.maps.InfoWindow({
				content: routeMapInfoWindowHtml(this.props.routeInfoHtml || (warehouse.label || "Warehouse")),
				maxWidth: 320
			});
			whMarker.addListener('click', function(){ whInfoWindow.open(map, whMarker); });
		}

		cities.forEach((c) => {
			var latLng = new window.google.maps.LatLng(parseFloat(c.lat), parseFloat(c.lng));
			bounds.extend(latLng);
			var marker = new window.google.maps.Marker({
				position: latLng,
				map: map,
				title: c.city || ""
			});
			var infowindow = new window.google.maps.InfoWindow({
				content: routeMapInfoWindowHtml('<b>' + (c.city || "") + '</b>'),
				maxWidth: 220
			});
			marker.addListener('click', function(){ infowindow.open(map, marker); });
		});

		if(!bounds.isEmpty()){
			map.fitBounds(bounds);
		}
	};
	render(){
		return <div id="routeMapPopupCanvas" style={{ width: "100%", height: "100%" }}></div>;
	}
}

function loadDateTimeScript(){
	// alert("timeDate");
	$('.datetimepicker_mask').datetimepicker({
		//mask:'39-19-9999 29:59',
		format:'d-m-Y'
	});
	$('.datetimepicker_date').datetimepicker({
		mask:'39-19-9999',
		format:'d-m-Y',
		timepicker:false
	});
    var index  =window.document.getElementsByTagName("script")[1]
    var script = window.document.createElement("script")
    script.src="https://www.jqueryscript.net/demo/Clean-jQuery-Date-Time-Picker-Plugin-datetimepicker/jquery.datetimepicker.js"
	//script.src="http://xdsoft.net/jqplugins/datetimepicker/"
	script.async=true
    script.defer = true
    index.parentNode.insertBefore(script,index)
}

function DateEditor () {}

// gets called once before the renderer is used
DateEditor.prototype.init = function(params) {
    // create the cell
    this.eInput = document.createElement('input');
    this.eInput.value = params.value;

    // https://jqueryui.com/datepicker/
    $(this.eInput).datetimepicker({
        dateFormat: "yy-mm-dd",
        changeMonth: true,
        changeYear: true,
        timepicker:false,
    });
};

// gets called once when grid ready to insert the element
DateEditor.prototype.getGui = function() {
    return this.eInput;
};

// focus and select can be done after the gui is attached
DateEditor.prototype.afterGuiAttached = function() {
    this.eInput.focus();
    this.eInput.select();
};

// returns the new value after editing
DateEditor.prototype.getValue = function() {
	// console.log(this.eInput.value);
    return this.eInput.value;
};

// any cleanup we need to be done here
DateEditor.prototype.destroy = function() {
    // but this example is simple, no cleanup, we could
    // even leave this method out as it's optional
};

// if true, then this editor will appear in a popup
DateEditor.prototype.isPopup = function() {
    // and we could leave this method out also, false is the default
    return false;
};

function NumericCellEditor() {
}

// gets called once before the renderer is used
NumericCellEditor.prototype.init = function (params) {
    // create the cell
    this.eInput = document.createElement('input');

    if (isCharNumeric(params.charPress)) {
        this.eInput.value = params.charPress;
    } else {
        if (params.value !== undefined && params.value !== null) {
            this.eInput.value = params.value;
        }
    }

    var that = this;
    this.eInput.addEventListener('keypress', function (event) {
        if (!isKeyPressedNumeric(event)) {
            that.eInput.focus();
            if (event.preventDefault) event.preventDefault();
        } else if (that.isKeyPressedNavigation(event)) {
            event.stopPropagation();
        }
    });

    // only start edit if key pressed is a number, not a letter
    var charPressIsNotANumber = params.charPress && ('1234567890'.indexOf(params.charPress) < 0);
    this.cancelBeforeStart = charPressIsNotANumber;
};

function getCharCodeFromEvent(event) {
    event = event || window.event;
    return (typeof event.which == "undefined") ? event.keyCode : event.which;
}

function isCharNumeric(charStr) {
    return !!/\d/.test(charStr);
}

function isCharDecimal(charStr) {
    return !!/\./.test(charStr);
}

function isKeyPressedNumeric(event) {
    const charCode = getCharCodeFromEvent(event);
    const charStr = String.fromCharCode(charCode);
    return isCharNumeric(charStr) || isCharDecimal(charStr);
}

NumericCellEditor.prototype.isKeyPressedNavigation = function (event) {
    return event.keyCode === 39
        || event.keyCode === 37;
};


// gets called once when grid ready to insert the element
NumericCellEditor.prototype.getGui = function () {
    return this.eInput;
};

// focus and select can be done after the gui is attached
NumericCellEditor.prototype.afterGuiAttached = function () {
    this.eInput.focus();
};

// returns the new value after editing
NumericCellEditor.prototype.isCancelBeforeStart = function () {
    return this.cancelBeforeStart;
};

// example - will reject the number if it contains the value 007
// - not very practical, but demonstrates the method.
NumericCellEditor.prototype.isCancelAfterEnd = function () {
    var value = this.getValue();
    return value.indexOf('007') >= 0;
};

// returns the new value after editing
NumericCellEditor.prototype.getValue = function () {
    return this.eInput.value;
};

// any cleanup we need to be done here
NumericCellEditor.prototype.destroy = function () {
    // but this example is simple, no cleanup, we could  even leave this method out as it's optional
};

// if true, then this editor will appear in a popup 
NumericCellEditor.prototype.isPopup = function () {
    // and we could leave this method out also, false is the default
    return false;
};

function distinctArrayBy(arr, propName) {
    var result = arr.reduce(function (arr1, e1) {
        var matches = arr1.filter(function (e2) {
            return e1[propName] == e2[propName];
        })
        if (matches.length == 0)
            arr1.push(e1)
        return arr1;
    }, []);

    return result;
}

function distinctArrayWithoutKeys(arr) {
    var result = arr.reduce(function (arr1, e1) {
        var matches = arr1.filter(function (e2) {
            return e1 == e2;
        })
        if (matches.length == 0)
            arr1.push(e1)
        return arr1;
    }, []);

    return result;
}